import httpRequest from './util/httpRequest.js'
import Fingerprint2 from 'fingerprintjs2'
import { isNil} from 'ramda'
import * as Sentry from '@sentry/browser'

let head = document.getElementsByTagName('HEAD')[0]
let link = document.createElement('link')
link.rel = 'stylesheet'
link.type = 'text/css'
link.href = 'https://rosetta-ai.github.io/sdk.shopline/spin.css'
head.appendChild(link)

const dateTime = Date.now()
const timestamp = Math.floor(dateTime / 1000)

class UserError extends Error {
    // you can do something inside
}

class SendQueryError extends Error {
    constructor(message) {
        super(message)
        this.name = 'SendQueryError'
    }
}
function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&")
}

function getProductGroupID() {
  let output = ''
  ;[...document.getElementsByTagName('script')].forEach(item => {
      if (item.innerText.indexOf('Product ID') !== -1) {
          let start = 0
          let end = 0
          let i = 0
          let j = 13 + 24 + 0
          let pre = ''
          let suf = ''

          do {
              i++
              pre = item.innerText.substr(item.innerText.indexOf('Product ID') - i, 1)
          } while (pre !== '{')

          do {
              j++
              suf = item.innerText.substr(item.innerText.indexOf('Product ID') + j, 1)
          } while (suf !== '}')

          output = item.innerText.substr(item.innerText.indexOf('Product ID') - i, i + j + 1)
          output = JSON.parse(output.replace(/\\/g, ''))['Product ID']
      }
  })
  return output
}

function getVariationID(group) {
  let first = '{\\"_id\\":\\"' + group + '\\"'
  let second = "}"
  let reg = escapeRegExp(first) + '(.*)' + escapeRegExp(second)
  let tmp, output = false

  ;[...document.getElementsByTagName('script')].forEach(item => {
    tmp = item.innerText.match(new RegExp(reg))
    if (tmp !== null) output = tmp[0]
  })

  if (output !== false) {
    let res = JSON.parse(output.replace(/\\/g, ''))
    return res.variations[0].key
  }

  return output
}

function localItemParser() {
  let item = null

  if (window.dataLayer) {
    window.dataLayer.forEach(arg => {
      let args = Array.prototype.slice.call(arg)
      args.forEach(arr => {
        if (arr.ecomm_prodid) item = arr.ecomm_prodid
      })
    })
  }

  if (item === null) {
    let group = getProductGroupID()
    let variation = getVariationID(group)
    if (group && variation) item = group + ':' + variation
  }

  return item
}

try {
    let initialize = () => {
        window.rosettaInit() // 初始化rosetta參數
        try {
            let userPromise = new Promise(function(resolve, reject) {
                // console.log('no login entity')
                setTimeout(() => {
                    // 沒有登入
                    rosetta.isLogin = false
                    rosetta
                        .createUserEntity()
                        .then(res => {
                            // 查詢到 user_id 建立 user entity 取得 rosetta 的 id
                            // console.log('res', res)
                            rosetta.user_entity = res.data.id
                            // console.log('res.data.ab', res.data.ab, typeof res.data.ab !== 'undefined')
                            rosetta.ab = typeof res.data.ab !== 'undefined' ? res.data.ab : ''
                            // console.log('res.data.ab', res.data.ab)
                            resolve('Success')
                            // console.log('rosetta.ab_experiments 3', rosetta.ab_experiments)
                        })
                        .catch(err => {
                            // 錯誤
                        })
                }, 1000)
            })

            const getUserEntity = userId => {
                // console.log('userId', userId)
                let href = userId.href
                // console.log('href', href)
                let arr = href.split('/')
                // console.log('arr', arr)
                rosetta.user_id = arr[arr.length - 2]
                // console.log('rosetta.user_id', rosetta.user_id, rosetta.user_id.indexOf('users') === -1)
                if (!isNil(rosetta.user_id) && rosetta.user_id.indexOf('users') === -1) {
                    rosetta.isLogin = true
                    // console.log('4')
                    rosetta
                        .createUserEntity()
                        .then(res => {
                            rosetta.getUser = true
                            // 查詢到 user_id 建立 user entity 取得 rosetta 的 id
                            rosetta.user_entity = res.data.id
                            // console.log('res.data.ab', res.data.ab, typeof res.data.ab !== 'undefined')
                            rosetta.ab = typeof res.data.ab !== 'undefined' ? res.data.ab : ''
                            // console.log('5')
                            // console.log('rosetta.ab_experiments 1', rosetta.ab_experiments)
                        })
                        .catch(err => {
                            // 錯誤
                        })
                }
            }

            const deleteGroupEvent = () => {
                const now = new Date()
                const year = now.getUTCFullYear()
                const beforeMonth = now.getUTCMonth() - 3 + 1
                const day = now.getUTCDate()
                const endDate = +new Date(year, beforeMonth, day)
                const endTimestamp = Math.floor(endDate / 1000)
                // console.log(timestamp, endTimestamp)
                if (localStorage.getItem('groupEvent') === null) return

                let groupEvent = JSON.parse(localStorage.getItem('groupEvent'))
                const lastGroup = groupEvent.filter(item => {
                    // console.log(Object.keys(item)[0] > endTimestamp)
                    return Object.keys(item)[0] > endTimestamp
                })
                localStorage.setItem('groupEvent', JSON.stringify(lastGroup))
            }

            if ($) {
                // console.log('index in')
                Sentry.init({
                    dsn: 'https://643b59682411428085f367db7bbc531a@sentry.io/1461710',
                    environment: 'Production',
                    beforeSend(event, hint) {
                        const error = hint.originalException
                        // console.log(error.name, error.message)
                        if (error instanceof UserError) {
                            return event
                        } else if (error instanceof SendQueryError) {
                            return event.message
                        }
                    },
                }) //
                let path = rosetta.getPath()
                let parsePath = path.split('/')

                setTimeout(function() {
                    let user = $('.member-myaccount-button')
                    let userPro = $('.NavigationBar-actionMenu-button.nav-color')
                    // console.log(user.length > 0, userPro.length > 0)
                    if ((user.length > 0 || userPro.length > 0) && !rosetta.getUser) {
                        // console.log('1')
                        if (user.length > 0) {
                            // console.log('2 a')
                            if (!isNil(user[0])) {
                                // console.log('3 a')
                                // console.log('event a', user[0])
                                getUserEntity(user[0])
                            }
                        } else if (userPro.length > 0) {
                            // console.log('2 b')
                            let userItems = $.grep(userPro, item => {
                                return (
                                    typeof $(item).attr('href') !== 'undefined' &&
                                    $(item)
                                        .attr('href')
                                        .indexOf('users') > -1
                                )
                            })
                            if (!isNil(userItems[0])) {
                                // console.log('3 b')
                                // console.log('event b', userItems[0])
                                getUserEntity(userItems[0])
                            }
                        }
                    }
                }, 4000)
                if (path === '/') {
                    // console.log('start index')
                    userPromise.then(() => {
                        deleteGroupEvent()
                        // startLoading()
                        rosetta.bindList()
                        rosetta.bindSelect()
                        rosetta.createQuery()
                    })
                } else if (window.location.host === 'www.ctshop.me' && parsePath[1] === 'pages') {
                    if (parsePath[2] === 'w--chicwomen' || parsePath[2] === 'kids') {
                        userPromise.then(() => {
                            deleteGroupEvent()
                            // startLoading()
                            rosetta.bindList()
                            rosetta.bindSelect()
                            rosetta.createQuery()
                        })
                    }
                } else if (
                    window.location.host === 'www.allinhome.store' &&
                    parsePath[1] === 'pages' &&
                    encodeURI(parsePath[2]) === '%25E7%25A6%25AE%25E7%2589%25A9%25E5%25B0%2588%25E5%258D%2580'
                ) {
                    userPromise.then(() => {
                        deleteGroupEvent()
                        // startLoading()
                        rosetta.bindList()
                        rosetta.bindSelect()
                        rosetta.createQuery()
                    })
                } else if (parsePath[1] === 'products') {
                    // console.log('start products')
                    userPromise.then(() => {
                        deleteGroupEvent()
                        rosetta.bindNormalList()
                        rosetta.bindSelect()
                        // 綁定item// 綁定select
                        let queryId
                        // 判斷product頁是否有 queryid

                        dataLayer.forEach(arg => {
                            let args = Array.prototype.slice.call(arg)
                            args.forEach(arr => {
                                if (arr.ecomm_prodid) {
                                    queryId = arr.ecomm_prodid
                                }
                            })
                        })

                        if(location.hostname === 'www.funhouse.biz'){
                            let urlSearch = location.search
                            let urlId = !isNil(location.search) && location.search.indexOf('?variation=') > -1 ? location.search.replace('?variation=',''):''
                            ;[...document.getElementsByTagName('script')].forEach(item => {
                                if (item.innerText.indexOf('Product ID') !== -1) {
                                    queryId = item.innerText.substr(item.innerText.indexOf('Product ID') + 13, 24)
                                    // console.log('當queryId小於正常值,從新抓取Product ID值','currQueryId:',currQueryId)
                                }
                            })
                            if(!isNil(urlId) && urlId.length > 0){
                                queryId = `${queryId}:${urlId}`
                            }
                        }

                        if (window.location.href.indexOf('drqq') > -1) {
                            queryId = localItemParser()
                        }

                        if (window.location.href.indexOf('pgmall') > -1) {
                            let urlId = !isNil(location.search) && location.search.indexOf('?variation=') > -1 ? location.search.replace('?variation=',''):''
                            ;[...document.getElementsByTagName('script')].forEach(item => {
                                if (item.innerText.indexOf('Product ID') !== -1) {
                                    let start = 0
                                    let end = 0
                                    let i = 0
                                    let j = 13 + 24 + 0
                                    let pre = ''
                                    let suf = ''

                                    do {
                                        i++
                                        pre = item.innerText.substr(item.innerText.indexOf('Product ID') - i, 1)
                                    } while (pre !== '{')

                                    do {
                                        j++
                                        suf = item.innerText.substr(item.innerText.indexOf('Product ID') + j, 1)
                                    } while (suf !== '}')

                                    queryId = item.innerText.substr(item.innerText.indexOf('Product ID') - i, i + j + 1)
                                    queryId = JSON.parse(queryId.replace(/\\/g,""))['Product ID']
                                    console.log(queryId)
                                }
                            })
                            if(!isNil(urlId) && urlId.length > 0){
                                queryId = `${queryId}:${urlId}`
                            }
                        }

                        if (isNil(queryId)) {
                            // 當queryId小於正常值,從新抓取Product ID值
                            ;[...document.getElementsByTagName('script')].forEach(item => {
                                if (item.innerText.indexOf('Product ID') !== -1) {
                                    queryId = item.innerText.substr(item.innerText.indexOf('Product ID') + 13, 24)
                                    // console.log('當queryId小於正常值,從新抓取Product ID值','currQueryId:',currQueryId)
                                }
                            })
                        }

                        if (!queryId) {
                            return
                        }

                        if (typeof queryId !== 'undefined') {
                            let local_id = JSON.parse(localStorage.getItem('queue')) || null
                            let groupEvent = JSON.parse(localStorage.getItem('groupEvent')) || null
                            let clickRosetta = []

                            // console.log('groupEvent', groupEvent)
                            // 當localstorage groupEvent存在,抓符合local_id的資料
                            if (!isNil(groupEvent)) {
                                // console.log('groupEvent', groupEvent)
                                clickRosetta = groupEvent.reverse().filter((item, index) => {
                                    // console.log('item', item)
                                    for (let property in item) {
                                        // console.log('item[property]', item[property])
                                        return item[property][1] === local_id && item[property][0] === 'click'
                                    }
                                })
                                // console.log('clickRosetta', clickRosetta)
                            }

                            if (!isNil(local_id)) {
                                if (queryId === local_id) {
                                    // 當queryId和local_id相同
                                    // console.log('id相同', local_id)
                                    rosetta.createQuery(local_id)
                                } else if (queryId && queryId.indexOf(local_id) > -1) {
                                    // 當queryId有包含local_id
                                    // console.log('當queryId有包含local_id', 'queryId:', queryId)
                                    rosetta.createQuery(queryId)
                                } else if (queryId && local_id.indexOf(queryId) > -1) {
                                    // 當local_id有包含queryId
                                    // console.log('當local_id有包含queryId', 'local_id:', local_id)
                                    rosetta.createQuery(local_id)
                                } else {
                                    rosetta.createQuery(queryId) // 有local_id但比對錯誤,可能是留下的local_id
                                }
                            } else {
                                rosetta.createQuery(queryId) // 沒local_id
                            }
                            try {
                                // console.log('query event start', 'local_id', local_id)
                                if (!isNil(local_id)) {
                                    // 如果local_id存在,開始set groupEvent
                                    // console.log('local_id', local_id)
                                    let recentItemSource
                                    let recentItemWorthAb
                                    let recentItemEvent
                                    // console.log('當queryId有包含local_id,移除localStorage,送出queryId事件')
                                    if (clickRosetta.length > 0) {
                                        // 如果有抓到符合groupEvent的資料
                                        recentItemSource = Object.values(clickRosetta[0])[0][2]
                                        recentItemWorthAb = Object.values(clickRosetta[0])[0][3]
                                        recentItemEvent = Object.values(clickRosetta[0])[0][0]
                                        // console.log(
                                        //     'recentItemSource',
                                        //     recentItemSource,
                                        //     'recentItemWorthAb',
                                        //     recentItemWorthAb,
                                        //     'recentItemEvent',
                                        //     recentItemEvent
                                        // )
                                    }
                                    if (location.hostname === 'www.sole143.me') {
                                        // console.log('sole143.me start')
                                        let diffLocalId = local_id
                                        let diffQueryId = queryId
                                        // console.log('diffLocalId', diffLocalId, 'diffQueryId', diffQueryId)
                                        if (diffLocalId.indexOf(':') > -1) {
                                            diffLocalId = diffLocalId.split(':')[0]
                                        }
                                        if (diffQueryId.indexOf(':') > -1) {
                                            diffQueryId = diffQueryId.split(':')[0]
                                        }
                                        // console.log('diffLocalId:', diffLocalId, 'diffQueryId:', diffQueryId)

                                        if (diffQueryId.indexOf(diffLocalId) > -1) {
                                            // console.log('diff ok')
                                            if (recentItemWorthAb) {
                                                if (!isNil(recentItemSource)) {
                                                    // console.log('sendEvent 01 01')
                                                    rosetta.sendEvent(
                                                        queryId,
                                                        recentItemEvent,
                                                        recentItemSource,
                                                        recentItemWorthAb
                                                    )
                                                } else {
                                                    // console.log('sendEvent 01 02')
                                                    rosetta.sendEvent(
                                                        queryId,
                                                        recentItemEvent,
                                                        recentItemSource,
                                                        recentItemWorthAb
                                                    )
                                                }
                                            } else {
                                                // console.log('sendEvent 01 03')
                                                rosetta.sendEvent(
                                                    queryId,
                                                    recentItemEvent,
                                                    recentItemSource,
                                                    recentItemWorthAb
                                                )
                                            }
                                        }
                                    } else if (queryId.indexOf(local_id) > -1) {
                                        // console.log('sendEvent 01', local_id, queryId)

                                        if (recentItemWorthAb) {
                                            if (!isNil(recentItemSource)) {
                                                // console.log('sendEvent 01 01')
                                                rosetta.sendEvent(
                                                    local_id,
                                                    recentItemEvent,
                                                    recentItemSource,
                                                    recentItemWorthAb
                                                )
                                            } else {
                                                // console.log('sendEvent 01 02')
                                                rosetta.sendEvent(
                                                    local_id,
                                                    recentItemEvent,
                                                    recentItemSource,
                                                    recentItemWorthAb
                                                )
                                            }
                                        } else {
                                            // console.log('sendEvent 01 03')
                                            rosetta.sendEvent(
                                                local_id,
                                                recentItemEvent,
                                                recentItemSource,
                                                recentItemWorthAb
                                            )
                                        }
                                    } else if (local_id.indexOf(queryId) > -1) {
                                        // console.log('sendEvent 02', local_id, queryId)
                                        if (recentItemWorthAb) {
                                            if (!isNil(recentItemSource)) {
                                                // console.log('sendEvent 02 01')
                                                rosetta.sendEvent(
                                                    local_id,
                                                    recentItemEvent,
                                                    recentItemSource,
                                                    recentItemWorthAb
                                                )
                                            } else {
                                                // console.log('sendEvent 02 02')
                                                rosetta.sendEvent(
                                                    local_id,
                                                    recentItemEvent,
                                                    recentItemSource,
                                                    recentItemWorthAb
                                                )
                                            }
                                        } else {
                                            rosetta.sendEvent(
                                                local_id,
                                                recentItemEvent,
                                                recentItemSource,
                                                recentItemWorthAb
                                            )
                                        }
                                    } else {
                                        localStorage.removeItem('queue')
                                        // console.log('no sendEvent')
                                        // 有可能local_id傳的時候,就和query_id不一樣,連結的問題
                                        // 有可能local_id留著,但直接輸入網址道別的品項
                                    }
                                } else if (!local_id) {
                                    // console.log('no local_id')
                                }
                            } catch (error) {
                                // 不支援 localStorage
                            }
                        }
                    })
                } else if (parsePath[1] === 'categories') {
                    // console.log('start categories')
                    userPromise.then(() => {
                        deleteGroupEvent()
                        rosetta.bindNormalList()
                        // console.log('start bind select')
                        rosetta.bindSelect()
                        rosetta.createQuery()
                        // console.log('start create query')
                        // rosetta.createQuery(cateType)
                    })
                } else if (parsePath[1] === 'checkout') {
                    userPromise.then(() => {
                        // console.log('start checkout')
                        let items = $('.cart-item')
                        $.map(items, item => {
                            let $item = $(item)
                            const numberReg = /\d+/g
                            if (
                                !isNil($item.find('.item-price .price-label')) &&
                                !isNil($item.find('.item-price .price-label').text()) &&
                                !isNil(
                                    $item
                                        .find('.item-price .price-label')
                                        .text()
                                        .match(numberReg)
                                ) &&
                                $item
                                    .find('.item-price .price-label')
                                    .text()
                                    .match(numberReg)[0] !== '0'
                            ) {
                                // console.log($item)
                                let productId = $item.attr('product-id')
                                let variation = $item.attr('data-variation-id')
                                try {
                                    let groupEvent = JSON.parse(localStorage.getItem('groupEvent')) || null
                                    let local_id
                                    let recentItemSource
                                    let itemWorthyAb

                                    if (productId) {
                                        if (variation) {
                                            local_id = `${productId}:${variation}`
                                        } else {
                                            local_id = productId
                                        }
                                    }

                                    let clickRosetta = groupEvent.map((item, index) => {
                                        // console.log('item', item)
                                        for (let property in item) {
                                            // console.log('item[property]', item[property])
                                            if (
                                                item[property][1] === local_id &&
                                                item[property][0] === 'select' &&
                                                isNil(item.delete)
                                            ) {
                                                // console.log(
                                                //     'recentItemSource corrent',
                                                //     item[property],
                                                //     item[property][2]
                                                // )
                                                recentItemSource = item[property][2]
                                                itemWorthyAb = item[property][3]
                                                const newItem = Object.assign({ delete: timestamp }, item)
                                                return newItem
                                            } else {
                                                return item
                                            }
                                        }
                                    })
                                    // console.log(
                                    //     'clickRosetta',
                                    //     clickRosetta,
                                    //     'recentItemSource',
                                    //     recentItemSource,
                                    //     typeof recentItemSource !== 'undefined'
                                    // )

                                    if (typeof recentItemSource !== 'undefined' && rosetta.ab !== '') {
                                        // console.log('clickRosetta', clickRosetta)
                                        rosetta.sendEvent(local_id, 'buy', recentItemSource, itemWorthyAb)
                                    }else{
                                        rosetta.sendEvent(local_id, 'buy', null, false)
                                    }
                                    localStorage.setItem('groupEvent', JSON.stringify(clickRosetta))
                                } catch (error) {
                                    // error
                                }
                            }
                        })
                    })
                }
            }
        } catch (error) {
            // 如果 jQuery 還沒初始完成，500ms 後重試
            setTimeout(function() {
                initialize()
            }, 500)
            throw new UserError(error)
        }
    }

    try {
        window.rosetta = {
            init(obj) {
                // console.log('obj', obj)
                Fingerprint2.get(function(components) {
                    // console.log('components',components)
                    let fp = Fingerprint2.x64hash128(
                        components
                            .map(function(pair) {
                                return pair.value
                            })
                            .join(),
                        31
                    )
                    rosetta.fingerPrint = fp
                    // console.log('rosetta.fingerPrint',rosetta.fingerPrint)
                })

                if (typeof obj.config !== 'undefined' && obj.config.length > 0) {
                    let path = rosetta.getPath()

                    let parsePath = path.split('/')

                    rosetta.token = obj.token
                    // console.log('obj.config', obj.config)
                    obj.config.map(item => {
                        // console.log('boj item', item)
                        if (path === '/' && item.page === 'index') {
                            if (typeof item.engine_id !== 'undefined') {
                                rosetta.engine_id = item.engine_id
                            }
                            if (typeof item.override !== 'undefined') {
                                rosetta.override = item.override
                            }
                        } else if (parsePath[1] === 'categories' && item.page === 'categories') {
                            if (typeof item.engine_id !== 'undefined') {
                                rosetta.engine_id = item.engine_id
                            }
                            if (typeof item.override !== 'undefined') {
                                rosetta.override = item.override
                            }
                        } else if (parsePath[1] === 'products' && item.page === 'products') {
                            // console.log('products 1')
                            if (typeof item.engine_id !== 'undefined') {
                                rosetta.engine_id = item.engine_id
                            }
                            if (typeof item.override !== 'undefined') {
                                rosetta.override = item.override
                                // console.log('obj override 2', item.override, rosetta.override)
                            }
                        } else if (parsePath[1] === 'checkout' && item.page === 'checkout') {
                            if (typeof item.engine_id !== 'undefined') {
                                rosetta.engine_id = item.engine_id
                            }
                            if (typeof item.override !== 'undefined') {
                                rosetta.override = item.override
                            }
                        } else if (parsePath[1] === 'pages' && item.page === 'pages') {
                            if (typeof item.engine_id !== 'undefined') {
                                rosetta.engine_id = item.engine_id
                            }
                            if (typeof item.override !== 'undefined') {
                                rosetta.override = item.override
                            }
                        }
                    })
                } else {
                    // console.log('obj 3')
                    rosetta.token = typeof obj.token === 'string' && obj.token.length > 0 ? obj.token : ''
                    rosetta.engine_id =
                        typeof obj.engine_id === 'string' && obj.engine_id.length > 0 ? obj.engine_id : ''
                    rosetta.override = typeof obj.override === 'boolean' ? obj.override : false
                }

                if (obj.override) {
                    rosetta.override = true
                }
            },
            getPath() {
                return window.location.pathname
            },
            getUrl() {
                return window.location.href
            },
            createUserEntity() {
                const http = httpRequest(rosetta.token)
                if (typeof rosetta.fingerPrint !== '') {
                    // console.log('fingerPrint !== undefined')
                    // console.log(rosetta.isLogin, rosetta.user_id, rosetta.fingerPrint)
                    if (rosetta.isLogin) {
                        // console.log('createUserEntity login true')
                        return http.post('entity', {
                            type: 'user',
                            name: `shopline:${rosetta.user_id}`,
                            id: rosetta.user_id,
                            fingerprint: rosetta.fingerPrint,
                        })
                    } else {
                        // console.log('createUserEntity login false')
                        return http.post('entity', {
                            type: 'user',
                            name: `fingerPrint:${rosetta.fingerPrint}`,
                            // id: '',
                            fingerprint: rosetta.fingerPrint,
                        })
                    }
                }
            },
            createQuery(item_id) {
                // console.log('createQuery:id', item_id)
                if (isNil(item_id)) {
                    // console.log('local_retrieval undefined')
                    rosetta.sendQuery()
                }
                else {
                    const http = httpRequest(rosetta.token)
                    http.post('entity/local_retrieval', {
                        local_id: item_id,
                    }).then(res => {
                        // console.log('local_retrieval res', res)
                        // console.log('sendQuery arg')
                        rosetta.sendQuery(res.data.id)
                    })
                }
            },
            sendQuery(item_entity) {
                // console.log('sendQuery', rosetta.isLogin, rosetta.user_entity, rosetta.engine_id)
                if (typeof rosetta.isLogin === 'boolean' && !isNil(rosetta.user_entity) && !isNil(rosetta.engine_id)) {
                    // console.log('sendQuery ok1')
                    const http = httpRequest(rosetta.token)
                    if (isNil(item_entity)) {
                        // console.log('sendQuery no item_entity')
                        let host = window.location.host
                        if (host === 'www.ctshop.me') {
                            let path = rosetta.getPath()
                            let parsePath = path.split('/')

                            if (parsePath[1] === 'pages') {
                                if (parsePath[2] === 'kids') {
                                    let arr = ['K - 小城市. 男童', 'K - 兒童｜配件', 'K - 小城市. 女童', 'K-兒童｜優惠特賣', 'K-兒童｜主題派對']
                                    http.post(`engine/${rosetta.engine_id}/query`, {
                                        user: rosetta.user_entity,
                                        filters: JSON.stringify({category_tree: [arr[Math.floor(Math.random() * arr.length)]]})
                                    }).then(res => {
                                        // console.log('sendQuery success')
                                        rosetta.source = res.data.id
                                        // console.log('rosetta.source', res, res.data, rosetta.source)
                                        rosetta.getQueryEntity(res.data)
                                        if (item_entity === null) {
                                            throw new SendQueryError(item_entity)
                                        }
                                    })
                                }

                                if (parsePath[2] === 'w--chicwomen') {
                                    let arr = ['內衣', '上衣', '下身', '外套', '連身', 'CT- 人氣商品', 'KOA｜女士包包']
                                    http.post(`engine/${rosetta.engine_id}/query`, {
                                        user: rosetta.user_entity,
                                        filters: JSON.stringify({category_tree: ['W-女士｜款式分類', arr[Math.floor(Math.random() * arr.length)]]})
                                    }).then(res => {
                                        // console.log('sendQuery success')
                                        rosetta.source = res.data.id
                                        // console.log('rosetta.source', res, res.data, rosetta.source)
                                        rosetta.getQueryEntity(res.data)
                                        if (item_entity === null) {
                                            throw new SendQueryError(item_entity)
                                        }
                                    })
                                }
                            }
                        } else {
                            http.post(`engine/${rosetta.engine_id}/query`, {
                                user: rosetta.user_entity,
                            }).then(res => {
                                // console.log('sendQuery success')
                                rosetta.source = res.data.id
                                // console.log('rosetta.source', res, res.data, rosetta.source)
                                rosetta.getQueryEntity(res.data)
                                if (item_entity === null) {
                                    throw new SendQueryError(item_entity)
                                }
                            })
                        }
                    } else {
                        // console.log('sendQuery item_entity')
                        // console.log('rosetta.engine_id','user,entity','item,entity',rosetta.engine_id,rosetta.user_entity,item_id)
                        http.post(`engine/${rosetta.engine_id}/query`, {
                            user: rosetta.user_entity,
                            item: item_entity,
                        }).then(res => {
                            rosetta.source = res.data.id
                            // console.log('rosetta.source', res, res.data, rosetta.source)
                            rosetta.getQueryEntity(res.data)
                        })
                    }
                } else {
                    rosetta.sendQueryTimes += 1
                    if (rosetta.sendQueryTimes < 10) {
                        setTimeout(() => {
                            rosetta.sendQuery(item_entity)
                        }, 1000)
                    }
                }
            },
            getQueryEntity(res) {
                // console.log('getQueryEntity', res)
                if (res.data) {
                    // console.log('res.data',res.data);
                    const promise = res.data.map(item => {
                        //  console.log('item',item)
                        //  console.log('item.property',item.property)
                        return item
                    })
                    Promise.all(promise).then(function(lists) {
                        const query_id = typeof res.id !== 'undefined' ? res.id : ''
                        rosetta.createUI(lists, query_id)
                    })
                }
            },
            sendQueryDelivered(...arg) {
                let path = rosetta.getPath()
                let parsePath = path.split('/')
                if (rosetta.engine_id === '') {
                    return
                }
                if (parsePath[1] === 'categories') {
                    return
                }
                // console.log('arg[2]', arg[2], JSON.stringify(arg[2]))
                if (isNil(arg[1])) {
                    return
                }
                const http = httpRequest(rosetta.token)
                http.post('query/delivered', {
                    query_id: !isNil(arg[0]) && typeof arg[0] === 'string' && arg[0].length > 0 ? arg[0] : null,
                    count: typeof arg[1] === 'string' ? arg[1] : '0',
                    content:
                        !isNil(arg[2]) && typeof arg[2] === 'object' && arg[2].length > 0
                            ? JSON.stringify(arg[2])
                            : null,
                })
            },
            createUI(lists, query_id) {
                // console.log('createUI start')
                if ($('#rosetta-query-container').length === 0) {
                    let host = window.location.host
                    switch (host) {
                        case 'www.allyoung.com.tw':
                            // console.log('get started')
                            rosetta.doUISpecial_Allyoung(lists, query_id)
                            break
                        case 'www.sole143.me':
                            rosetta.doUISpecial_Sole143(lists, query_id)
                            break
                        case 'www.drqq.toys':
                            rosetta.doUISpecial_Drqq(lists, query_id)
                            break
                        // case 'www.tuanyuannuts.com':
                        //     rosetta.doUISpecial_Tuanyuannuts(lists, query_id)
                        //     break
                        // case 'www.buymeat.co':
                        //     rosetta.doUISpecial_Buymeat(lists, query_id)
                        //     break
                        // case 'www.supercolor.com.tw':
                        //     rosetta.doUISpecial_Supercolor(lists, query_id)
                        //     break
                        // case 'www.allinhome.store':
                        //     rosetta.doUISpecial_AllInHome(lists, query_id)
                        //     break
                        // case 'www.funhouse.biz':
                        //     rosetta.doUISpecial_FunHouse(lists, query_id)
                        //     break
                        // case 'www.yohopower.tw':
                        //     rosetta.doUISpecial_YohoPower(lists, query_id)
                        //     break
                        // case 'www.hlolo.com.tw':
                        //     rosetta.doUISpecial_Hlolo(lists, query_id)
                        //     break
                        case 'www.justforshow.com.tw':
                            rosetta.doUISpecial_JustForShow(lists, query_id)
                            break
                        case 'www.amiidbeauty.com':
                            rosetta.doUISpecial_Amiid(lists, query_id)
                            break
                        default:
                            // console.log('missing me?')
                            rosetta.doUINormal(lists, query_id)
                    }
                }
            },

            doUISpecial_Amiid(lists, query_id) {
                let path = rosetta.getPath()
                let parsePath = path.split('/')
                let container
                let test1
                let test2 = null

                if (path === '/') {
                    if (rosetta.ab === 'on' || rosetta.ab === '') {
                            $(
                                '<div class="Grid-row-wrapper"><div class="Grid-row"><div class="container global-primary"><div class="container-md-height" style="height: 100%; table-layout: fixed; width: 100%; margin-bottom: 2%;"><div class="row row-md-height"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%; text-align: center;"><p class="global-primary dark-primary section-title" style="margin: auto; color: #666; font-size: x-large; font-weight: bold;">你可能會喜歡&nbsp;<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div></div><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%;"><div style="height: 100%;"><div class="box-info"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div></div></div></div></div></div></div></div>'
                            ).insertAfter(
                                $('.CustomPage').children('.Grid-row-wrapper').eq(0)
                            )
                            container = $('#rosetta-query-container')
                        }
                        let limits = 4
                        let iterator = 0
                        let haystack = []
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class = "global-primary dark-primary price price-crossed">
              NT$${property.price}</div>
              <div class="price-sale price ">
              NT$${property.sale_price}
              </div></div>`
                                            : `<div class="global-primary dark-primary price">
              NT$${property.price}
              </div>`

                                    container.append(
                                        `
                <div class="product-item col-xs-6 col-md-3" data-item-type="${property.type}">
                  <a href="${property.link}" class="quick-cart-item">
                    <div class="boxify-image-wrapper">
                      <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
                      </div>
                    </div>
                    <div class="info-box">
                      <div class="info-box-inner-wrapper">
                        <div class="title text-primary-color title-container ellipsis" data-max-height="45">
                          ${property.name}
                        </div>
                        <div class="quick-cart-price">
                          ${showPrice}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindList()
                } else if (parsePath[1] === 'categories') {
                    let container
                    if (rosetta.ab === 'on' || rosetta.ab === '') {
                        if ($('.ProductList-info').length === 0) {
                            throw new UserError('justforshow category dom change')
                        }
                        $(
                            '<h3 class="ProductDetail-relatedProducts-title primary-border-color-after global-primary dark-primary">流行趨勢<a style="display: inline-block;vertical-align: top;padding-top: 3px;margin-left:5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;"></a></h3>'
                        ).insertAfter($('.ProductList-info'))
                        $(
                            '<div class="ProductDetail-relatedProducts-list" id="rosetta-query-container" style="position:relative;"></div>'
                        ).insertAfter($('.ProductDetail-relatedProducts-title'))

                        container = $('#rosetta-query-container')
                        let limits = 4
                        let iterator = 0
                        let haystack = []
                        lists.forEach(list => {
                            // console.log('show list', list)
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class="price-sale price ">
          NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
          NT$${property.price}</div>`
                                            : `<div class="global-primary dark-primary price">
          NT$${property.price}
          </div>`
                                    container.append(
                                        `
              <div class="product-item">
                <div class="ng-scope">
                  <a href="${property.link}" class="quick-cart-item js-quick-cart-item" target="_blank">
                    <div class="boxify-image-wrapper js-quick-boxify-image">
                      <div class="boxify-image center-contain " style="background-image:url(${property.image_link})"></div>
                    </div>
                    <div class="info-box">
                      <div class="info-box-inner-wrapper">
                        <div class="title text-primary-color">${property.name}</div>
                        <div class="quick-cart-price">
                          ${showPrice}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        // console.log('query_id, iterator, haystack', query_id, iterator, haystack)
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindNormalList()
                    }
                } else if (parsePath[1] === 'products') {
                    if (typeof parsePath[2] !== 'undefined') {
                        let container
                        if (rosetta.ab === 'on' || rosetta.ab === '') {
                            if ($('.ProductDetail-relatedProducts').length === 0) {
                                throw new UserError('justforshow products dom change')
                            }
                            if (rosetta.override && lists) {
                                $('.ProductDetail-relatedProducts-list')
                                    .prev('h3')
                                    .remove()
                                $('.ProductDetail-relatedProducts-list').remove()
                            }
                            $('.ProductDetail-relatedProducts').append(
                                '<h3 class="ProductDetail-relatedProducts-title primary-border-color-after global-primary dark-primary">適合一起選購<a style="display: inline-block;margin-left:5px;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h3>'
                            )
                            $('.ProductDetail-relatedProducts').append(
                                '<div class="ProductDetail-relatedProducts-list" id="rosetta-query-container" style="position:relative;"></div>'
                            )
                            container = $('#rosetta-query-container')
                            let limits = 4
                            let iterator = 0
                            let haystack = []
                            lists.forEach(list => {
                                // console.log('show list', list)
                                const { property, item } = list
                                if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                    if (rosetta.ab === 'on' || rosetta.ab === '') {
                                        if (
                                            property.name.indexOf('fingerPrint') > -1 ||
                                            isNil(property.local_id) ||
                                            isNil(property.price)
                                        ) {
                                            return
                                        }
                                        let showPrice =
                                            typeof property.sale_price !== 'undefined'
                                                ? `<div class="price-sale price ">
                NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
                NT$${property.price}</div>`
                                                : `<div class="global-primary dark-primary price">
                NT$${property.price}
                </div>`
                                        container.append(
                                            `
                <div class="product-item">
                  <div class="ng-scope">
                    <a href="${property.link}" class="quick-cart-item js-quick-cart-item" target="_blank">
                      <div class="boxify-image-wrapper js-quick-boxify-image">
                        <div class="boxify-image center-contain " style="background-image:url(${property.image_link})"></div>
                      </div>
                      <div class="info-box">
                        <div class="info-box-inner-wrapper">
                          <div class="title text-primary-color">${property.name}</div>
                          <div class="quick-cart-price">
                            ${showPrice}
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                `
                                        )
                                    }
                                    haystack.push(item)
                                    iterator += 1
                                }
                            })
                            // console.log('query_id, iterator, haystack', query_id, iterator, haystack)
                            rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                            rosetta.bindNormalList()
                        }

                        // rosetta.bindList()
                    }
                }
            },

            doUISpecial_JustForShow(lists, query_id) {
                let path = rosetta.getPath()
                let parsePath = path.split('/')
                if (path === '/') {
                    let container
                    // if (rosetta.override) {
                    //     const removeItem = $('.Grid-row-wrapper')
                    //         .get()
                    //         .filter(
                    //             item =>
                    //                 typeof $(item).find('span') !== 'undefined' &&
                    //                 $(item)
                    //                     .find('span')
                    //                     .text()
                    //                     .indexOf('熱賣 TOP 10') > -1
                    //         )
                    //     removeItem[0].remove()
                    // }
                    if (rosetta.ab === 'on' || rosetta.ab === '') {
                        if ($('.Grid-row-wrapper').first().length === 0) {
                            throw new UserError('justforshow index dom change')
                        }

                        $(
                            '<div class="Grid-row-wrapper rosetta"><div class="Grid-row"><div class="Grid-item"><p class="global-primary dark-primary section-title">推薦商品<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div></div></div>'
                        ).insertBefore($('.m-full-width').first())

                        $('.rosetta').append(
                            '<div class="Grid-row"><div class="Grid-item"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div></div></div>'
                        )
                        container = $('#rosetta-query-container')
                        let limits = 8
                        let iterator = 0
                        let haystack = []
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class="price-sale price ">
                NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
                NT$${property.price}</div>`
                                            : `<div class="global-primary dark-primary price">
                NT$${property.price}
          </div>`
                                    container.append(
                                        `
              <div class="product-item col-xs-6 col-md-3">
                <div>
                  <a href="${property.link}" class="quick-cart-item" target="_blank">
                    <div class="boxify-image-wrapper">
                      <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
                      </div>
                    </div>
                    <div class="info-box">
                      <div class="info-box-inner-wrapper">
                        <div class="title text-primary-color title-container ellipsis" data-max-height="45">
                          ${property.name}
                        </div>
                        <div class="quick-cart-price">
                          ${showPrice}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindList()
                    }
                } else if (parsePath[1] === 'categories') {
                    let container
                    if (rosetta.ab === 'on' || rosetta.ab === '') {
                        if ($('.ProductList-info').length === 0) {
                            throw new UserError('justforshow category dom change')
                        }
                        $(
                            '<h3 class="ProductDetail-relatedProducts-title primary-border-color-after global-primary dark-primary">推薦產品<a style="display: inline-block;vertical-align: top;padding-top: 3px;margin-left:5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;"></a></h3>'
                        ).insertAfter($('.ProductList-info'))
                        $(
                            '<div class="ProductDetail-relatedProducts-list" id="rosetta-query-container" style="position:relative;"></div>'
                        ).insertAfter($('.ProductDetail-relatedProducts-title'))

                        container = $('#rosetta-query-container')
                        let limits = 4
                        let iterator = 0
                        let haystack = []
                        lists.forEach(list => {
                            // console.log('show list', list)
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class="price-sale price ">
          NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
          NT$${property.price}</div>`
                                            : `<div class="global-primary dark-primary price">
          NT$${property.price}
          </div>`
                                    container.append(
                                        `
              <div class="product-item">
                <div class="ng-scope">
                  <a href="${property.link}" class="quick-cart-item js-quick-cart-item" target="_blank">
                    <div class="boxify-image-wrapper js-quick-boxify-image">
                      <div class="boxify-image center-contain " style="background-image:url(${property.image_link})"></div>
                    </div>
                    <div class="info-box">
                      <div class="info-box-inner-wrapper">
                        <div class="title text-primary-color">${property.name}</div>
                        <div class="quick-cart-price">
                          ${showPrice}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        // console.log('query_id, iterator, haystack', query_id, iterator, haystack)
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindNormalList()
                    }
                } else if (parsePath[1] === 'products') {
                    if (typeof parsePath[2] !== 'undefined') {
                        let container
                        if (rosetta.ab === 'on' || rosetta.ab === '') {
                            if ($('.ProductDetail-relatedProducts').length === 0) {
                                throw new UserError('justforshow products dom change')
                            }
                            if (rosetta.override && lists) {
                                $('.ProductDetail-relatedProducts-list')
                                    .prev('h3')
                                    .remove()
                                $('.ProductDetail-relatedProducts-list').remove()
                            }
                            $('.ProductDetail-relatedProducts').append(
                                '<h3 class="ProductDetail-relatedProducts-title primary-border-color-after global-primary dark-primary">推薦產品<a style="display: inline-block;margin-left:5px;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h3>'
                            )
                            $('.ProductDetail-relatedProducts').append(
                                '<div class="ProductDetail-relatedProducts-list" id="rosetta-query-container" style="position:relative;"></div>'
                            )
                            container = $('#rosetta-query-container')
                            let limits = 4
                            let iterator = 0
                            let haystack = []
                            lists.forEach(list => {
                                // console.log('show list', list)
                                const { property, item } = list
                                if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                    if (rosetta.ab === 'on' || rosetta.ab === '') {
                                        if (
                                            property.name.indexOf('fingerPrint') > -1 ||
                                            isNil(property.local_id) ||
                                            isNil(property.price)
                                        ) {
                                            return
                                        }
                                        let showPrice =
                                            typeof property.sale_price !== 'undefined'
                                                ? `<div class="price-sale price ">
                NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
                NT$${property.price}</div>`
                                                : `<div class="global-primary dark-primary price">
                NT$${property.price}
                </div>`
                                        container.append(
                                            `
                <div class="product-item">
                  <div class="ng-scope">
                    <a href="${property.link}" class="quick-cart-item js-quick-cart-item" target="_blank">
                      <div class="boxify-image-wrapper js-quick-boxify-image">
                        <div class="boxify-image center-contain " style="background-image:url(${property.image_link})"></div>
                      </div>
                      <div class="info-box">
                        <div class="info-box-inner-wrapper">
                          <div class="title text-primary-color">${property.name}</div>
                          <div class="quick-cart-price">
                            ${showPrice}
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                `
                                        )
                                    }
                                    haystack.push(item)
                                    iterator += 1
                                }
                            })
                            // console.log('query_id, iterator, haystack', query_id, iterator, haystack)
                            rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                            rosetta.bindNormalList()
                        }

                        // rosetta.bindList()
                    }
                }
            },

            doUISpecial_Sole143(lists, query_id) {
                let path = rosetta.getPath()
                let parsePath = path.split('/')
                if (path === '/') {
                    let container
                    if (rosetta.ab === 'on' && rosetta.override) {
                        const removeItem = $('.Grid-row-wrapper')
                            .get()
                            .filter(
                                item =>
                                    typeof $(item).find('span') !== 'undefined' &&
                                    $(item)
                                        .find('span')
                                        .text()
                                        .indexOf('熱賣 TOP 10') > -1
                            )
                        removeItem[0].remove()
                    }
                    if (rosetta.ab === 'on' || rosetta.ab === '') {
                        if ($('.Grid-row-wrapper').first().length === 0) {
                            throw new UserError('sole143 index dom change')
                        }

                        $(
                            '<div class="Grid-row-wrapper rosetta"><div class="Grid-row"><div class="Grid-item"><p class="global-primary dark-primary section-title">推薦商品<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div></div></div>'
                        ).insertAfter($('.Grid-row-wrapper').first())

                        $('.rosetta').append(
                            '<div class="Grid-row"><div class="Grid-item"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div></div></div>'
                        )
                        container = $('#rosetta-query-container')
                        let limits = 8
                        let iterator = 0
                        let haystack = []
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class="price-sale price ">
                NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
                NT$${property.price}</div>`
                                            : `<div class="global-primary dark-primary price">
                NT$${property.price}
          </div>`
                                    container.append(
                                        `
              <div class="product-item col-xs-6 col-md-3">
                <div>
                  <a href="${property.link}" class="quick-cart-item" target="_blank">
                    <div class="boxify-image-wrapper">
                      <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
                      </div>
                    </div>
                    <div class="info-box">
                      <div class="info-box-inner-wrapper">
                        <div class="title text-primary-color title-container ellipsis" data-max-height="45">
                          ${property.name}
                        </div>
                        <div class="quick-cart-price">
                          ${showPrice}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindList()
                    }
                } else if (parsePath[1] === 'categories') {
                    let container
                    if (rosetta.ab === 'on' || rosetta.ab === '') {
                        if ($('.ProductList-info').length === 0) {
                            throw new UserError('sole143 category dom change')
                        }
                        $(
                            '<h3 class="ProductDetail-relatedProducts-title primary-border-color-after global-primary dark-primary">推薦產品<a style="display: inline-block;vertical-align: top;padding-top: 3px;margin-left:5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;"></a></h3>'
                        ).insertAfter($('.ProductList-info'))
                        $(
                            '<div class="ProductDetail-relatedProducts-list" id="rosetta-query-container" style="position:relative;"></div>'
                        ).insertAfter($('.ProductDetail-relatedProducts-title'))

                        container = $('#rosetta-query-container')
                        let limits = 4
                        let iterator = 0
                        let haystack = []
                        lists.forEach(list => {
                            // console.log('show list', list)
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class="price-sale price ">
          NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
          NT$${property.price}</div>`
                                            : `<div class="global-primary dark-primary price">
          NT$${property.price}
          </div>`
                                    container.append(
                                        `
              <div class="product-item">
                <div class="ng-scope">
                  <a href="${property.link}" class="quick-cart-item js-quick-cart-item" target="_blank">
                    <div class="boxify-image-wrapper js-quick-boxify-image">
                      <div class="boxify-image center-contain " style="background-image:url(${property.image_link})"></div>
                    </div>
                    <div class="info-box">
                      <div class="info-box-inner-wrapper">
                        <div class="title text-primary-color">${property.name}</div>
                        <div class="quick-cart-price">
                          ${showPrice}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        // console.log('query_id, iterator, haystack', query_id, iterator, haystack)
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindNormalList()
                    }
                } else if (parsePath[1] === 'products') {
                    if (typeof parsePath[2] !== 'undefined') {
                        let container
                        if (rosetta.ab === 'on' || rosetta.ab === '') {
                            if ($('.ProductDetail-relatedProducts').length === 0) {
                                throw new UserError('sole143 products dom change')
                            }
                            if (rosetta.override && lists) {
                                $('.ProductDetail-relatedProducts-list')
                                    .prev('h3')
                                    .remove()
                                $('.ProductDetail-relatedProducts-list').remove()
                            }
                            $('.ProductDetail-relatedProducts').append(
                                '<h3 class="ProductDetail-relatedProducts-title primary-border-color-after global-primary dark-primary">推薦產品<a style="display: inline-block;margin-left:5px;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h3>'
                            )
                            $('.ProductDetail-relatedProducts').append(
                                '<div class="ProductDetail-relatedProducts-list" id="rosetta-query-container" style="position:relative;"></div>'
                            )
                            container = $('#rosetta-query-container')
                            let limits = 4
                            let iterator = 0
                            let haystack = []
                            lists.forEach(list => {
                                // console.log('show list', list)
                                const { property, item } = list
                                if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                    if (rosetta.ab === 'on' || rosetta.ab === '') {
                                        if (
                                            property.name.indexOf('fingerPrint') > -1 ||
                                            isNil(property.local_id) ||
                                            isNil(property.price)
                                        ) {
                                            return
                                        }
                                        let showPrice =
                                            typeof property.sale_price !== 'undefined'
                                                ? `<div class="price-sale price ">
                NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
                NT$${property.price}</div>`
                                                : `<div class="global-primary dark-primary price">
                NT$${property.price}
                </div>`
                                        container.append(
                                            `
                <div class="product-item">
                  <div class="ng-scope">
                    <a href="${property.link}" class="quick-cart-item js-quick-cart-item" target="_blank">
                      <div class="boxify-image-wrapper js-quick-boxify-image">
                        <div class="boxify-image center-contain " style="background-image:url(${property.image_link})"></div>
                      </div>
                      <div class="info-box">
                        <div class="info-box-inner-wrapper">
                          <div class="title text-primary-color">${property.name}</div>
                          <div class="quick-cart-price">
                            ${showPrice}
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                `
                                        )
                                    }
                                    haystack.push(item)
                                    iterator += 1
                                }
                            })
                            // console.log('query_id, iterator, haystack', query_id, iterator, haystack)
                            rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                            rosetta.bindNormalList()
                        }

                        // rosetta.bindList()
                    }
                }
            },
            doUISpecial_Allyoung(lists, query_id) {
                let path = rosetta.getPath()
                let parsePath = path.split('/')
                if (path === '/') {
                    // let container
                    // if (rosetta.ab === 'on' || rosetta.ab === '') {
                    //   $('<div class="Grid-row-wrapper rosetta"><div class="Grid-row"><div class="Grid-item"><p class="global-primary dark-primary section-title">推薦商品 <span style="color: #777;font-weight: lighter;text-transform: lowercase;">( powered by <span style="text-transform: none;">Rosetta.ai</span> )</span></p></div></div></div>').insertAfter($('.page-item-products-container').first().parent().parent().parent())
                    //   $('.rosetta').append('<div class="Grid-row"><div class="Grid-item"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div></div></div>')
                    //   container = $('#rosetta-query-container')
                    // }
                    // let limits = 8
                    // let iterator = 0
                    // let haystack = []
                    // lists.forEach((list) => {
                    //   const { property, item } = list
                    //   if (list.property && $.inArray(item, haystack) < 0 && iterator < limits) {
                    //     if (rosetta.ab === 'on' || rosetta.ab === '') {
                    //       let showPrice = typeof property.sale_price !== 'undefined' ? `<div class="price-sale price ">
                    //   NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
                    //   NT$${property.price}</div>` : `<div class="global-primary dark-primary price">
                    //   NT$${property.price}
                    //   </div>`
                    //       container.append(
                    //         `
                    //     <div class="product-item col-xs-6 col-md-3">
                    //       <div>
                    //         <a href="${property.link}" class="quick-cart-item" >
                    //           <div class="boxify-image-wrapper">
                    //             <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${list.image_link})">
                    //             </div>
                    //           </div>
                    //           <div class="info-box">
                    //             <div class="info-box-inner-wrapper">
                    //               <div class="title text-primary-color title-container ellipsis" data-max-height="45">
                    //                 ${property.name}
                    //               </div>
                    //               <div class="quick-cart-price">
                    //                 ${showPrice}
                    //               </div>
                    //             </div>
                    //           </div>
                    //         </a>
                    //       </div>
                    //     </div>
                    //     `
                    //       )
                    //     }
                    //     haystack.push(item)
                    //     iterator += 1
                    //   }
                    // })
                    // rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                    // rosetta.bindList()
                } else if (parsePath[1] === 'categories') {
                } else if (parsePath[1] === 'products') {
                    if (typeof parsePath[2] !== 'undefined') {
                        let container
                        if (rosetta.ab === 'on' || rosetta.ab === '') {
                            // console.log('allyoung')
                            if (rosetta.override && lists) {
                                $('.ProductDetail-relatedProducts-list')
                                    .prev('h3')
                                    .remove()
                                $('.ProductDetail-relatedProducts-list').remove()
                            }
                            if ($('.fb-comments').length === 0 && $('.ProductDetail-relatedProducts').length === 0) {
                                throw new UserError('allyoung products dom change')
                            }

                            if ($('.fb-comments').length > 0) {
                                $(
                                    '<h3 class="ProductDetail-relatedProducts-title primary-border-color-after global-primary dark-primary">推薦產品<a style="display: inline-block;vertical-align: top;padding-top: 4px;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;"></a></h3>'
                                ).insertBefore($('.fb-comments'))
                                $(
                                    '<div class="ProductDetail-relatedProducts-list" id="rosetta-query-container" style="position:relative;"></div>'
                                ).insertAfter('.ProductDetail-relatedProducts-title')
                            } else if ($('.ProductDetail-relatedProducts').length > 0) {
                                $('.ProductDetail-relatedProducts').append(
                                    '<h3 class="ProductDetail-relatedProducts-title primary-border-color-after global-primary dark-primary">推薦產品<a style="display: inline-block;vertical-align: top;padding-top: 4px;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;"></a></h3>'
                                )
                                $('.ProductDetail-relatedProducts').append(
                                    '<div class="ProductDetail-relatedProducts-list" id="rosetta-query-container" style="position:relative;"></div>'
                                )
                            }
                            container = $('#rosetta-query-container')

                            let limits = 4
                            let iterator = 0
                            let haystack = []
                            lists.forEach(list => {
                                const { property, item } = list
                                if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                    if (rosetta.ab === 'on' || rosetta.ab === '') {
                                        if (
                                            property.name.indexOf('fingerPrint') > -1 ||
                                            isNil(property.local_id) ||
                                            isNil(property.price)
                                        ) {
                                            return
                                        }
                                        let showPrice =
                                            typeof property.sale_price !== 'undefined'
                                                ? `<div class="price-sale price ">
              NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
              NT$${property.price}</div>`
                                                : `<div class="global-primary dark-primary price">
              NT$${property.price}
              </div>`

                                        container.append(
                                            `
                <div class="product-item">
                  <div class="ng-scope">
                    <a href="${property.link}" class="quick-cart-item js-quick-cart-item" >
                      <div class="boxify-image-wrapper js-quick-boxify-image">
                        <div class="boxify-image center-contain " style="background-image:url(${property.image_link})"></div>
                      </div>
                      <div class="info-box">
                        <div class="info-box-inner-wrapper">
                          <div class="title text-primary-color">${property.name}</div>
                          <div class="quick-cart-price">
                            ${showPrice}
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                `
                                        )
                                    }
                                    haystack.push(item)
                                    iterator += 1
                                }
                            })
                            rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                            rosetta.bindNormalList()
                        }
                    }
                }
            },
            doUISpecial_Drqq(lists, query_id) {
                // console.log('drqq')
                let path = rosetta.getPath()
                let parsePath = path.split('/')
                if (path === '/') {
                    let container
                    if (rosetta.ab === 'on' || rosetta.ab === '') {
                        if (
                            $('.container.global-primary')
                                .find('.box-info .description')
                                .first().length === 0
                        ) {
                            throw new UserError('drqq index dom change')
                        }

                        $(
                            '<p class="global-primary dark-primary section-title rosetta-title">推薦商品<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;margin-left:5px" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p>'
                        ).insertAfter(
                            $('.container.global-primary')
                                .find('.box-info .description')
                                .first()
                        )
                        $(
                            '<div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div>'
                        ).insertAfter($('.rosetta-title'))

                        container = $('#rosetta-query-container')
                        let limits = 12
                        let iterator = 0
                        let haystack = []
                        // console.log('lists',lists)
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                // console.log('list.name',list.name)
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class = "global-primary dark-primary price price-crossed ">
          NT$${property.price}</div>
          <div class="price-sale price ">
          NT$${property.sale_price}
          </div></div>`
                                            : `<div class="global-primary dark-primary price">
          NT$${property.price}
          </div>`
                                    container.append(
                                        `
            <div class="product-item col-xs-6 col-md-3" data-item-type="${property.type}">
              <a href="${property.link}" class="quick-cart-item">
                <div class="boxify-image-wrapper">
                  <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
                  </div>
                </div>
                <div class="info-box">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color title-container ellipsis" data-max-height="45">
                      ${property.name}
                    </div>
                    <div class="quick-cart-price">
                      ${showPrice}
                    </div>
                  </div>
                </div>
              </a>
            </div>
            `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindList()
                    }
                } else if (parsePath[1] === 'categories') {
                    let container
                    if (rosetta.ab === 'on' || rosetta.ab === '') {
                        if ($('.product-list-container').length === 0) {
                            throw new UserError('drqq categories dom change')
                        }

                        $('.product-list-container').append(
                            '<h2 class="global-primary dark-primary">你可能喜歡<a style="display: inline-block;vertical-align: top;padding-top: 2px;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;"></a></h2>'
                        )
                        $('.product-list-container').append(
                            '<div class="row" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
                        )

                        container = $('#rosetta-query-container').children()
                        let limits = 8
                        let iterator = 0
                        let haystack = []
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class = "global-primary dark-primary price price-crossed ">
          NT$${property.price}</div>
          <div class="price-sale price ">
          NT$${property.sale_price}
          </div></div>`
                                            : `<div class="global-primary dark-primary price">
          NT$${property.price}
          </div>`
                                    container.append(
                                        `
            <li class="boxify-item product-item">
              <a href="${property.link}" class="quick-cart-item">
                <div class="boxify-image-wrapper">
                  <div class="boxify-image center-contain sl-lazy-image " style="background-image:url(${property.image_link})"></div>
                </div>
                <div class="info-box" style="">
                  <div class="info-box-inner-wrapper">
                  <div class="title text-primary-color title-container ellipsis " ng-non-bindable="" style="overflow-wrap: break-word;">${property.name}</div>
                    ${showPrice}
                  </div>
                </div>
              </a>
            </li>
            `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindNormalList()
                    }
                } else if (parsePath[1] === 'products') {
                    // console.log('render商品頁')
                    // console.log('rosetta.override',rosetta.override)
                    let container
                    if (rosetta.ab === 'on' || rosetta.ab === '') {
                        if (rosetta.override && lists) {
                            // 如果是複寫相關商品，就移除相關商品 DOM
                            // console.log('remove');
                            $('.related-products')
                                .parent()
                                .prev('h2')
                                .remove()
                            $('.related-products')
                                .parent()
                                .remove()
                        }

                        if ($('.fb-comments').length === 0 && $('h2.rosetta-primary').length === 0) {
                            throw new UserError('drqq products dom change')
                        }
                        // console.log('.fb-comments',$('.fb-comments'))
                        $(
                            '<h2 class="global-primary dark-primary rosetta-primary">推薦產品 <a style="display: inline-block;vertical-align: top;padding-top: 2px;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h2>'
                        ).insertBefore($('.fb-comments'))
                        // console.log('.global-primary.dark-primary',$('.global-primary.dark-primary'))
                        $(
                            '<div class="row" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
                        ).insertAfter($('h2.rosetta-primary'))
                        container = $('#rosetta-query-container').children()
                        let limits = 4
                        let iterator = 0
                        let haystack = []
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class = "global-primary dark-primary price price-crossed ">
          NT$${property.price}</div>
          <div class="price-sale price ">
          NT$${property.sale_price}
          </div></div>`
                                            : `<div class="global-primary dark-primary price">
          NT$${property.price}
          </div>`
                                    container.prepend(
                                        `
            <li class="boxify-item product-item">
              <a href="${property.link}">
                <div class="boxify-image-wrapper">
                  <div class="boxify-image center-contain sl-lazy-image " style="background-image:url(${property.image_link})"></div>
                </div>
                <div class="info-box" style="">
                  <div class="info-box-inner-wrapper">
                  <div class="title text-primary-color title-container ellipsis " ng-non-bindable="" style="overflow-wrap: break-word;">${property.name}</div>
                    ${showPrice}
                  </div>
                </div>
              </a>
            </li>
            `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindNormalList()
                    }
                }
            },

          //   doUISpecial_Tuanyuannuts(lists, query_id) {
          //       let path = rosetta.getPath()
          //       let parsePath = path.split('/')
          //       let container
          //       if (path === '/') {
          //           if (rosetta.ab === 'on' || rosetta.ab === '') {
          //               if ($('.page-item-products-container').first().length === 0) {
          //                   throw new UserError('Tuanyuannuts index dom change')
          //               }
          //               $(
          //                   '<p class="global-primary dark-primary section-title">推薦商品<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p>'
          //               ).insertAfter($('.page-item-products-container').first())
          //               $(
          //                   '<div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div>'
          //               ).insertAfter($('.section-title:eq(1)'))
          //               container = $('#rosetta-query-container')
          //               let limits = 4
          //               let iterator = 0
          //               let haystack = []
          //               // console.log('lists',lists)
          //               lists.forEach(list => {
          //                   const { property, item } = list
          //                   if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
          //                       if (rosetta.ab === 'on' || rosetta.ab === '') {
          //                           if (
          //                               property.name.indexOf('fingerPrint') > -1 ||
          //                               isNil(property.local_id) ||
          //                               isNil(property.price)
          //                           ) {
          //                               return
          //                           }
          //                           // console.log('list.name',list.name)
          //                           let showPrice =
          //                               typeof property.sale_price !== 'undefined'
          //                                   ? `<div class = "global-primary dark-primary price price-crossed ">
          // NT$${property.price}</div>
          // <div class="price-sale price ">
          // NT$${property.sale_price}
          // </div></div>`
          //                                   : `<div class="global-primary dark-primary price">
          // NT$${property.price}
          // </div>`
          //                           container.append(
          //                               `
          //   <div class="product-item col-xs-6 col-md-3" data-item-type="${property.type}">
          //     <a href="${property.link}" class="quick-cart-item">
          //       <div class="boxify-image-wrapper">
          //         <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
          //         </div>
          //       </div>
          //       <div class="info-box">
          //         <div class="info-box-inner-wrapper">
          //           <div class="title text-primary-color title-container ellipsis" data-max-height="45">
          //             ${property.name}
          //           </div>
          //           <div class="quick-cart-price">
          //             ${showPrice}
          //           </div>
          //         </div>
          //       </div>
          //     </a>
          //   </div>
          //   `
          //                           )
          //                       }
          //                       haystack.push(item)
          //                       iterator += 1
          //                   }
          //               })
          //               rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
          //               rosetta.bindList()
          //           }
          //       } else if (parsePath[1] === 'categories') {
          //           let container
          //           if (rosetta.ab === 'on' || rosetta.ab === '') {
          //               if ($('.product-list-container .page-bar').length === 0) {
          //                   throw new UserError('Tuanyuannuts category dom change')
          //               }
          //               $(
          //                   '<h2 class="global-primary dark-primary">你可能喜歡 <a style="display: inline-block;vertical-align: top;padding-top: 2px;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h2>'
          //               ).insertAfter('.product-list-container .page-bar')
          //               $(
          //                   '<div class="row" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
          //               ).insertAfter('h2.global-primary.dark-primary')
          //               container = $('#rosetta-query-container').children()
          //               let limits = 8
          //               let iterator = 0
          //               let haystack = []
          //               // console.log('lists',lists)
          //               lists.forEach(list => {
          //                   const { property, item } = list
          //                   if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
          //                       if (rosetta.ab === 'on' || rosetta.ab === '') {
          //                           if (
          //                               property.name.indexOf('fingerPrint') > -1 ||
          //                               isNil(property.local_id) ||
          //                               isNil(property.price)
          //                           ) {
          //                               return
          //                           }
          //                           let showPrice =
          //                               typeof property.sale_price !== 'undefined'
          //                                   ? `<div class = "global-primary dark-primary price price-crossed ">
          // NT$${property.price}</div>
          // <div class="price-sale price ">
          // NT$${property.sale_price}
          // </div></div>`
          //                                   : `<div class="global-primary dark-primary price">
          // NT$${property.price}
          // </div>`

          //                           container.append(
          //                               `
          //   <li class="boxify-item product-item">
          //     <a href="${property.link}" class="quick-cart-item">
          //       <div class="boxify-image-wrapper">
          //         <div class="boxify-image center-contain sl-lazy-image " style="background-image:url(${property.image_link})"></div>
          //       </div>
          //       <div class="info-box" style="">
          //         <div class="info-box-inner-wrapper">
          //         <div class="title text-primary-color title-container ellipsis " ng-non-bindable="" style="overflow-wrap: break-word;">${property.name}</div>
          //           ${showPrice}
          //         </div>
          //       </div>
          //     </a>
          //   </li>
          //   `
          //                           )
          //                       }
          //                       haystack.push(item)
          //                       iterator += 1
          //                   }
          //               })
          //               rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
          //               rosetta.bindNormalList()
          //           }
          //       } else if (parsePath[1] === 'products') {
          //           // console.log('render商品頁')
          //           let container
          //           if (rosetta.ab === 'on' || rosetta.ab === '') {
          //               if ($('.fb-comments').length === 0 && $('.product-detail-container').length === 0) {
          //                   throw new UserError('Tuanyuannuts products dom change')
          //               }
          //               if (rosetta.override && lists) {
          //                   // 如果是複寫相關商品，就移除相關商品 DOM
          //                   $('.related-products')
          //                       .parent()
          //                       .prev('h2')
          //                       .remove()
          //                   $('.related-products')
          //                       .parent()
          //                       .remove()
          //               }
          //               if ($('.fb-comments').length > 0) {
          //                   $(
          //                       '<h2 class="global-primary dark-primary rosetta-primary">推薦產品 <a style="display: inline-block;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h2>'
          //                   ).insertBefore($('.fb-comments'))
          //                   // console.log('.global-primary.dark-primary',$('.global-primary.dark-primary'))
          //                   $(
          //                       '<div class="row" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
          //                   ).insertAfter($('h2.rosetta-primary'))
          //               } else if ($('.product-detail-container').length > 0) {
          //                   $('.product-detail-container').append(
          //                       '<h2 class="global-primary dark-primary">推薦產品<a style="display: inline-block;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h2>'
          //                   )
          //                   $('.product-detail-container').append(
          //                       '<div class="row" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
          //                   )
          //               }
          //               container = $('#rosetta-query-container').children()
          //               let limits = 4
          //               let iterator = 0
          //               let haystack = []
          //               // console.log('lists',lists)
          //               lists.forEach(list => {
          //                   const { property, item } = list
          //                   if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
          //                       if (rosetta.ab === 'on' || rosetta.ab === '') {
          //                           if (
          //                               property.name.indexOf('fingerPrint') > -1 ||
          //                               isNil(property.local_id) ||
          //                               isNil(property.price)
          //                           ) {
          //                               return
          //                           }
          //                           let showPrice =
          //                               typeof property.sale_price !== 'undefined'
          //                                   ? `<div class = "global-primary dark-primary price price-crossed ">
          //     NT$${property.price}</div>
          //     <div class="price-sale price ">
          //     NT$${property.sale_price}
          //     </div></div>`
          //                                   : `<div class="global-primary dark-primary price">
          //     NT$${property.price}
          //     </div>`

          //                           container.append(
          //                               `
          //       <li class="boxify-item product-item">
          //         <a href="${property.link}">
          //           <div class="boxify-image-wrapper">
          //             <div class="boxify-image center-contain sl-lazy-image " style="background-image:url(${property.image_link})"></div>
          //           </div>
          //           <div class="info-box" style="">
          //             <div class="info-box-inner-wrapper">
          //             <div class="title text-primary-color title-container ellipsis " ng-non-bindable="" style="overflow-wrap: break-word;">${property.name}</div>
          //              ${showPrice}
          //             </div>
          //           </div>
          //         </a>
          //       </li>
          //       `
          //                           )
          //                       }
          //                       haystack.push(item)
          //                       iterator += 1
          //                   }
          //               })
          //               rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
          //               rosetta.bindNormalList()
          //           }
          //       }
          //   },
          //   doUISpecial_Buymeat(lists, query_id) {
          //       let path = rosetta.getPath()
          //       let parsePath = path.split('/')
          //       if (path === '/') {
          //           let container
          //           if (rosetta.ab === 'on' || rosetta.ab === '') {
          //               if (
          //                   $('.page-item-products-container')
          //                       .first()
          //                       .parent().length === 0
          //               ) {
          //                   throw new UserError('Buymeat index dom change')
          //               }
          //               $(
          //                   '<p class="global-primary dark-primary section-title">推薦商品<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p>'
          //               ).insertBefore(
          //                   $('.page-item-products-container')
          //                       .first()
          //                       .parent()
          //               )
          //               $('.page-item-products-container')
          //                   .first()
          //                   .parent()
          //                   .prepend(
          //                       '<div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div>'
          //                   )
          //               container = $('#rosetta-query-container')
          //               let limits = 12
          //               let iterator = 0
          //               let haystack = []
          //               // console.log('lists',lists)
          //               lists.forEach(list => {
          //                   const { property, item } = list
          //                   if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
          //                       if (rosetta.ab === 'on' || rosetta.ab === '') {
          //                           if (
          //                               property.name.indexOf('fingerPrint') > -1 ||
          //                               isNil(property.local_id) ||
          //                               isNil(property.price)
          //                           ) {
          //                               return
          //                           }
          //                           let showPrice =
          //                               typeof property.sale_price !== 'undefined'
          //                                   ? `<div class = "global-primary dark-primary price price-crossed ">
          //   NT$${property.price}</div>
          //   <div class="price-sale price ">
          //   NT$${property.sale_price}
          //   </div></div>`
          //                                   : `<div class="global-primary dark-primary price">
          //   NT$${property.price}
          //   </div>`
          //                           // console.log('list.name',list.name)
          //                           container.append(
          //                               `
          //   <div class="product-item col-xs-6 col-md-3" data-item-type="${property.type}">
          //     <a href="${property.link}" class="quick-cart-item">
          //       <div class="boxify-image-wrapper">
          //         <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
          //         </div>
          //       </div>
          //       <div class="info-box">
          //         <div class="info-box-inner-wrapper">
          //           <div class="title text-primary-color title-container ellipsis" data-max-height="45">
          //             ${property.name}
          //           </div>
          //           <div class="quick-cart-price">
          //             ${showPrice}
          //           </div>
          //         </div>
          //       </div>
          //     </a>
          //   </div>
          //   `
          //                           )
          //                       }
          //                       haystack.push(item)
          //                       iterator += 1
          //                   }
          //               })
          //               rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
          //               rosetta.bindList()
          //           }
          //       } else if (parsePath[1] === 'categories') {
          //           let container
          //           if (rosetta.ab === 'on' || rosetta.ab === '') {
          //               if ($('.product-list-container').length === 0) {
          //                   throw new UserError('Buymeat categories dom change')
          //               }
          //               // <span style="color: #777;font-weight: lighter;text-transform: lowercase;">( powered by <span style="text-transform: none;">Rosetta.ai</span> )</span>
          //               $('.product-list-container').append(
          //                   '<h2 class="global-primary dark-primary">你可能喜歡<a style="display: inline-block;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h2>'
          //               )
          //               $('.product-list-container').append(
          //                   '<div class="row" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
          //               )

          //               container = $('#rosetta-query-container').children()
          //               let limits = 8
          //               let iterator = 0
          //               let haystack = []
          //               // console.log('lists',lists)
          //               lists.forEach(list => {
          //                   const { property, item } = list
          //                   if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
          //                       if (rosetta.ab === 'on' || rosetta.ab === '') {
          //                           if (
          //                               property.name.indexOf('fingerPrint') > -1 ||
          //                               isNil(property.local_id) ||
          //                               isNil(property.price)
          //                           ) {
          //                               return
          //                           }
          //                           let showPrice =
          //                               typeof property.sale_price !== 'undefined'
          //                                   ? `<div class = "global-primary dark-primary price price-crossed ">
          //     NT$${property.price}</div>
          //     <div class="price-sale price ">
          //     NT$${property.sale_price}
          //     </div></div>`
          //                                   : `<div class="global-primary dark-primary price">
          //     NT$${property.price}
          //     </div>`
          //                           container.append(
          //                               `
          //       <li class="boxify-item product-item">
          //         <a href="${property.link}" class="quick-cart-item">
          //           <div class="boxify-image-wrapper">
          //             <div class="boxify-image center-contain sl-lazy-image " style="background-image:url(${property.image_link})"></div>
          //           </div>
          //           <div class="info-box" style="">
          //             <div class="info-box-inner-wrapper">
          //             <div class="title text-primary-color title-container ellipsis " ng-non-bindable="" style="overflow-wrap: break-word;">${property.name}</div>
          //               ${showPrice}
          //             </div>
          //           </div>
          //         </a>
          //       </li>
          //       `
          //                           )
          //                       }
          //                       haystack.push(item)
          //                       iterator += 1
          //                   }
          //               })
          //               rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
          //               rosetta.bindNormalList()
          //           }
          //       } else if (parsePath[1] === 'products') {
          //           let container
          //           if (rosetta.ab === 'on' || rosetta.ab === '') {
          //               if ($('.fb-comments').length === 0 && $('.product-detail-container').length === 0) {
          //                   throw new UserError('Buymeat products dom change')
          //               }
          //               if (rosetta.override && lists) {
          //                   // 如果是複寫相關商品，就移除相關商品 DOM
          //                   $('.related-products')
          //                       .parent()
          //                       .prev('h2')
          //                       .remove()
          //                   $('.related-products')
          //                       .parent()
          //                       .remove()
          //               }
          //               if ($('.fb-comments').length > 0) {
          //                   // <span style="color: #777;font-weight: lighter;text-transform: lowercase;">( powered by <span style="text-transform: none;">Rosetta.ai</span> )</span>
          //                   $(
          //                       '<h2 class="global-primary dark-primary rosetta-primary">推薦產品<a style="display: inline-block;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h2>'
          //                   ).insertBefore($('.fb-comments'))
          //                   // console.log('.global-primary.dark-primary',$('.global-primary.dark-primary'))
          //                   $(
          //                       '<div class="row" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
          //                   ).insertAfter($('h2.rosetta-primary'))
          //               } else if ($('.product-detail-container').length > 0) {
          //                   // <span style="color: #777;font-weight: lighter;text-transform: lowercase;">( powered by <span style="text-transform: none;">Rosetta.ai</span> )</span>
          //                   $('.product-detail-container').append(
          //                       '<h2 class="global-primary dark-primary">推薦產品<a style="display: inline-block;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h2>'
          //                   )
          //                   $('.product-detail-container').append(
          //                       '<div class="row" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
          //                   )
          //               }
          //               container = $('#rosetta-query-container').children()
          //               let limits = 8
          //               let iterator = 0
          //               let haystack = []
          //               // console.log('lists',lists)
          //               lists.forEach(list => {
          //                   const { property, item } = list
          //                   if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
          //                       if (rosetta.ab === 'on' || rosetta.ab === '') {
          //                           if (
          //                               property.name.indexOf('fingerPrint') > -1 ||
          //                               isNil(property.local_id) ||
          //                               isNil(property.price)
          //                           ) {
          //                               return
          //                           }
          //                           let showPrice =
          //                               typeof property.sale_price !== 'undefined'
          //                                   ? `<div class = "global-primary dark-primary price price-crossed ">
          // NT$${property.price}</div>
          // <div class="price-sale price ">
          // NT$${property.sale_price}
          // </div></div>`
          //                                   : `<div class="global-primary dark-primary price">
          // NT$${property.price}
          // </div>`
          //                           container.append(
          //                               `
          //   <li class="boxify-item product-item">
          //     <a href="${property.link}">
          //       <div class="boxify-image-wrapper">
          //         <div class="boxify-image center-contain sl-lazy-image " style="background-image:url(${property.image_link})"></div>
          //       </div>
          //       <div class="info-box" style="">
          //         <div class="info-box-inner-wrapper">
          //         <div class="title text-primary-color title-container ellipsis " ng-non-bindable="" style="overflow-wrap: break-word;">${property.name}</div>
          //           ${showPrice}
          //         </div>
          //       </div>
          //     </a>
          //   </li>
          //   `
          //                           )
          //                       }
          //                       haystack.push(item)
          //                       iterator += 1
          //                   }
          //               })
          //               rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
          //               rosetta.bindNormalList()
          //           }
          //       }
          //   },
          //   doUISpecial_Supercolor(lists, query_id) {
          //       let path = rosetta.getPath()
          //       let parsePath = path.split('/')
          //       if (path === '/') {
          //           let container

          //           if (rosetta.ab === 'on' || rosetta.ab === '') {
          //               $('.page-item-products-container')
          //                   .first()
          //                   .parent()
          //                   .parent()
          //                   .css('justify-content', 'center')

          //               $('.page-item-products-container')
          //                   .first()
          //                   .parent()
          //                   .prepend(
          //                       '<p class="global-primary dark-primary section-title rosetta-title" style="padding-top:30px;">推薦商品<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;"></a></p>'
          //                   )
          //               $(
          //                   '<div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div>'
          //               ).insertAfter('.rosetta-title')
          //               container = $('#rosetta-query-container')
          //               let limits = 12
          //               let iterator = 0
          //               let haystack = []
          //               // console.log('lists',lists)
          //               lists.forEach(list => {
          //                   const { property, item } = list
          //                   if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
          //                       if (rosetta.ab === 'on' || rosetta.ab === '') {
          //                           if (
          //                               property.name.indexOf('fingerPrint') > -1 ||
          //                               isNil(property.local_id) ||
          //                               isNil(property.price)
          //                           ) {
          //                               return
          //                           }
          //                           // console.log('list.name',list.name)
          //                           let showPrice =
          //                               typeof property.sale_price !== 'undefined'
          //                                   ? `
          //     <div class="price-sale price ">
          //     NT$${property.sale_price}
          //     </div><div class = "global-primary dark-primary price price-crossed ">
          //     NT$${property.price}</div>`
          //                                   : `<div class="global-primary dark-primary price">
          //     NT$${property.price}
          //     </div>`

          //                           container.append(
          //                               `
          //       <div class="product-item col-xs-6 col-md-3" data-item-type="${property.type}">
          //         <a href="${property.link}" class="quick-cart-item">
          //           <div class="boxify-image-wrapper">
          //             <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
          //             </div>
          //           </div>
          //           <div class="info-box">
          //             <div class="info-box-inner-wrapper">
          //               <div class="title text-primary-color title-container ellipsis" data-max-height="45">
          //                 ${property.name}
          //               </div>
          //               <div class="quick-cart-price">
          //                 ${showPrice}
          //               </div>
          //             </div>
          //           </div>
          //         </a>
          //       </div>
          //       `
          //                           )
          //                       }
          //                       haystack.push(item)
          //                       iterator += 1
          //                   }
          //               })
          //               rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
          //               rosetta.bindList()
          //           }
          //       } else if (parsePath[1] === 'categories') {
          //           let container
          //           if (rosetta.ab === 'on' || rosetta.ab === '') {
          //               $(
          //                   '<h3 class="global-primary dark-primary" style="font-size: 18px;padding-left: 14px;">你可能喜歡 <a style="display: inline-block;vertical-align: top;padding-top: 2px;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;"></a></h3>'
          //               ).insertBefore('.ProductList-list')
          //               $(
          //                   '<div id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
          //               ).insertAfter('h3.global-primary.dark-primary')

          //               container = $('#rosetta-query-container').children()
          //               let limits = 8
          //               let iterator = 0
          //               let haystack = []
          //               // console.log('lists',lists)
          //               lists.forEach(list => {
          //                   const { property, item } = list
          //                   if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
          //                       if (rosetta.ab === 'on' || rosetta.ab === '') {
          //                           if (
          //                               property.name.indexOf('fingerPrint') > -1 ||
          //                               isNil(property.local_id) ||
          //                               isNil(property.price)
          //                           ) {
          //                               return
          //                           }
          //                           let showPrice =
          //                               typeof property.sale_price !== 'undefined'
          //                                   ? `
          //                               <div class="price-sale price ">
          //                           NT$${property.sale_price}
          //                           </div>
          //                               <div class = "global-primary dark-primary price price-crossed ">
          //                           NT$${property.price}</div>
          //                           `
          //                                   : `<div class="global-primary dark-primary price">
          //                           NT$${property.price}
          //                           </div>`
          //                           container.append(
          //                               `
          //                           <li class="boxify-item product-item">
          //                               <a href="${property.link}" class="quick-cart-item">
          //                               <div class="boxify-image-wrapper">
          //                                   <div class="boxify-image center-contain sl-lazy-image " style="background-image:url(${property.image_link})"></div>
          //                               </div>
          //                               <div class="info-box" style="">
          //                                   <div class="info-box-inner-wrapper">
          //                                   <div class="title text-primary-color title-container ellipsis " ng-non-bindable="" style="overflow-wrap: break-word;">${property.name}</div>
          //                                   ${showPrice}
          //                                   </div>
          //                               </div>
          //                               </a>
          //                           </li>
          //                           `
          //                           )
          //                       }
          //                       haystack.push(item)
          //                       iterator += 1
          //                   }
          //               })
          //               rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
          //               rosetta.bindNormalList()
          //           }
          //       } else if (parsePath[1] === 'products') {
          //           // console.log('render商品頁')
          //           let container
          //           if (rosetta.ab === 'on' || rosetta.ab === '') {

          //               if ($('.fb-comments').length > 0) {
          //                   $(
          //                       '<h2 class="global-primary dark-primary rosetta-primary">推薦產品 <a style="display: inline-block;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h2>'
          //                   ).insertBefore($('.fb-comments'))
          //                   // console.log('.global-primary.dark-primary',$('.global-primary.dark-primary'))
          //                   $(
          //                       '<div class="row" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
          //                   ).insertAfter($('h2.rosetta-primary'))
          //               } else if ($('.ProductDetail-relatedProducts').length > 0) {
          //                   $('.ProductDetail-relatedProducts').append(
          //                       '<h3 class="ProductDetail-relatedProducts-title primary-border-color-after rosetta-title">推薦產品 <a style="display: inline-block;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 4px;"></a></h3>'
          //                   )

          //                   $(
          //                       '<div class="row" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
          //                   ).insertAfter('.rosetta-title')
          //               }
          //               container = $('#rosetta-query-container').children()
          //               let limits = 4
          //               let iterator = 0
          //               let haystack = []
          //               // console.log('lists',lists)
          //               lists.forEach(list => {
          //                   const { property, item } = list
          //                   if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
          //                       if (rosetta.ab === 'on' || rosetta.ab === '') {
          //                           if (
          //                               property.name.indexOf('fingerPrint') > -1 ||
          //                               isNil(property.local_id) ||
          //                               isNil(property.price)
          //                           ) {
          //                               return
          //                           }
          //                           let showPrice =
          //                               typeof property.sale_price !== 'undefined'
          //                                   ? `
          //                               <div class="price-sale price ">
          // NT$${property.sale_price}
          // </div>
          //                               <div class = "global-primary dark-primary price price-crossed ">
          // NT$${property.price}</div>`
          //                                   : `<div class="global-primary dark-primary price">
          // NT$${property.price}
          // </div>`

          //                           container.append(
          //                               `
          //   <li class="boxify-item product-item">
          //     <a href="${property.link}">
          //       <div class="boxify-image-wrapper">
          //         <div class="boxify-image center-contain sl-lazy-image " style="background-image:url(${property.image_link})"></div>
          //       </div>
          //       <div class="info-box" style="">
          //         <div class="info-box-inner-wrapper">
          //         <div class="title text-primary-color title-container ellipsis " ng-non-bindable="" style="overflow-wrap: break-word;">${property.name}</div>
          //         ${showPrice}
          //         </div>
          //       </div>
          //     </a>
          //   </li>
          //   `
          //                           )
          //                       }
          //                       haystack.push(item)
          //                       iterator += 1
          //                   }
          //               })
          //               rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
          //               rosetta.bindNormalList()
          //           }
          //       }
          //   },
          //   doUISpecial_AllInHome(lists, query_id) {
          //       let path = rosetta.getPath()
          //       let parsePath = path.split('/')
          //       if (path === '/') {
          //           let container

          //           if (rosetta.ab === 'on' || rosetta.ab === '') {
          //               if ($('.Grid-row-wrapper').eq(5).length === 0) {
          //                   throw new UserError('allinhome index dom change')
          //               }
          //               $(
          //                   '<div class="Grid-row-wrapper rosetta"><div class="Grid-row"><div class="Grid-item"><p class="global-primary dark-primary section-title">推薦商品<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div></div></div>'
          //               ).insertAfter($('.Grid-row-wrapper').eq(6))

          //               $('.rosetta').append(
          //                   '<div class="Grid-row"><div class="Grid-item"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div></div></div>'
          //               )
          //               container = $('#rosetta-query-container')
          //               let limits = 4
          //               let iterator = 0
          //               let haystack = []
          //               lists.forEach(list => {
          //                   const { property, item } = list
          //                   if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
          //                       if (rosetta.ab === 'on' || rosetta.ab === '') {
          //                           if (
          //                               property.name.indexOf('fingerPrint') > -1 ||
          //                               isNil(property.local_id) ||
          //                               isNil(property.price)
          //                           ) {
          //                               return
          //                           }
          //                           let showPrice =
          //                               typeof property.sale_price !== 'undefined'
          //                                   ? `<div class="price-sale price ">
          //       NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
          //       NT$${property.price}</div>`
          //                                   : `<div class="global-primary dark-primary price">
          //       NT$${property.price}
          // </div>`
          //                           container.append(
          //                               `
          //     <div class="product-item col-xs-6 col-md-3">
          //       <div>
          //         <a href="${property.link}" class="quick-cart-item" target="_blank">
          //           <div class="boxify-image-wrapper">
          //             <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
          //             </div>
          //           </div>
          //           <div class="info-box">
          //             <div class="info-box-inner-wrapper">
          //               <div class="title text-primary-color title-container ellipsis" data-max-height="45">
          //                 ${property.name}
          //               </div>
          //               <div class="quick-cart-price">
          //                 ${showPrice}
          //               </div>
          //             </div>
          //           </div>
          //         </a>
          //       </div>
          //     </div>
          //     `
          //                           )
          //                       }
          //                       haystack.push(item)
          //                       iterator += 1
          //                   }
          //               })
          //               rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
          //               rosetta.bindList()
          //           }
          //       } else if (parsePath[2] === '%E7%A6%AE%E7%89%A9%E5%B0%88%E5%8D%80') {
          //           let container

          //           if (rosetta.ab === 'on' || rosetta.ab === '') {
          //               if ($('.Grid-row-wrapper').eq(4).length === 0) {
          //                   throw new UserError('allinhome second index dom change')
          //               }
          //               $(
          //                   '<div class="Grid-row-wrapper rosetta"><div class="Grid-row"><div class="Grid-item"><p class="global-primary dark-primary section-title">推薦商品<a style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div></div></div>'
          //               ).insertAfter($('.Grid-row-wrapper').eq(4))

          //               $('.rosetta').append(
          //                   '<div class="Grid-row"><div class="Grid-item"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div></div></div>'
          //               )
          //               container = $('#rosetta-query-container')
          //               let limits = 4
          //               let iterator = 0
          //               let haystack = []
          //               lists.forEach(list => {
          //                   const { property, item } = list
          //                   if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
          //                       if (rosetta.ab === 'on' || rosetta.ab === '') {
          //                           if (
          //                               property.name.indexOf('fingerPrint') > -1 ||
          //                               isNil(property.local_id) ||
          //                               isNil(property.price)
          //                           ) {
          //                               return
          //                           }
          //                           let showPrice =
          //                               typeof property.sale_price !== 'undefined'
          //                                   ? `<div class="price-sale price ">
          //       NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
          //       NT$${property.price}</div>`
          //                                   : `<div class="global-primary dark-primary price">
          //       NT$${property.price}
          // </div>`
          //                           container.append(
          //                               `
          //     <div class="product-item col-xs-6 col-md-3">
          //       <div>
          //         <a href="${property.link}" class="quick-cart-item" target="_blank">
          //           <div class="boxify-image-wrapper">
          //             <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
          //             </div>
          //           </div>
          //           <div class="info-box">
          //             <div class="info-box-inner-wrapper">
          //               <div class="title text-primary-color title-container ellipsis" data-max-height="45">
          //                 ${property.name}
          //               </div>
          //               <div class="quick-cart-price">
          //                 ${showPrice}
          //               </div>
          //             </div>
          //           </div>
          //         </a>
          //       </div>
          //     </div>
          //     `
          //                           )
          //                       }
          //                       haystack.push(item)
          //                       iterator += 1
          //                   }
          //               })
          //               rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
          //               rosetta.bindList()
          //           }
          //       } else if (parsePath[1] === 'categories') {
          //           let container
          //           if (rosetta.ab === 'on' || rosetta.ab === '') {
          //               if ($('.ProductList-info').length === 0) {
          //                   throw new UserError('allinhome category dom change')
          //               }
          //               $(
          //                   '<h3 class="ProductDetail-relatedProducts-title primary-border-color-after global-primary dark-primary">推薦產品<a style="display: inline-block;vertical-align: top;padding-top: 3px;margin-left:5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;"></a></h3>'
          //               ).insertAfter($('.ProductList-info'))
          //               $(
          //                   '<div class="ProductDetail-relatedProducts-list" id="rosetta-query-container" style="position:relative;"></div>'
          //               ).insertAfter($('.ProductDetail-relatedProducts-title'))

          //               container = $('#rosetta-query-container')
          //               let limits = 4
          //               let iterator = 0
          //               let haystack = []
          //               lists.forEach(list => {
          //                   // console.log('show list', list)
          //                   const { property, item } = list
          //                   if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
          //                       if (rosetta.ab === 'on' || rosetta.ab === '') {
          //                           if (
          //                               property.name.indexOf('fingerPrint') > -1 ||
          //                               isNil(property.local_id) ||
          //                               isNil(property.price)
          //                           ) {
          //                               return
          //                           }
          //                           let showPrice =
          //                               typeof property.sale_price !== 'undefined'
          //                                   ? `<div class="price-sale price ">
          //     NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
          //     NT$${property.price}</div>`
          //                                   : `<div class="global-primary dark-primary price">
          //     NT$${property.price}
          //     </div>`
          //                           container.append(
          //                               `
          //         <div class="product-item">
          //           <div class="ng-scope">
          //             <a href="${property.link}" class="quick-cart-item js-quick-cart-item" target="_blank">
          //               <div class="boxify-image-wrapper js-quick-boxify-image">
          //                 <div class="boxify-image center-contain " style="background-image:url(${property.image_link})"></div>
          //               </div>
          //               <div class="info-box">
          //                 <div class="info-box-inner-wrapper">
          //                   <div class="title text-primary-color">${property.name}</div>
          //                   <div class="quick-cart-price">
          //                     ${showPrice}
          //                   </div>
          //                 </div>
          //               </div>
          //             </a>
          //           </div>
          //         </div>
          //         `
          //                           )
          //                       }
          //                       haystack.push(item)
          //                       iterator += 1
          //                   }
          //               })
          //               // console.log('query_id, iterator, haystack', query_id, iterator, haystack)
          //               rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
          //               rosetta.bindNormalList()
          //           }
          //       } else if (parsePath[1] === 'products') {
          //           let container
          //           if (rosetta.ab === 'on' || rosetta.ab === '') {
          //               if ($('.ProductDetail-relatedProducts').length === 0) {
          //                   throw new UserError('allinhome products dom change')
          //               }
          //               if (rosetta.override && lists) {
          //                   $('.ProductDetail-relatedProducts-list')
          //                       .prev('h3')
          //                       .remove()
          //                   $('.ProductDetail-relatedProducts-list').remove()
          //               }
          //               $('.ProductDetail-relatedProducts').append(
          //                   '<h3 class="ProductDetail-relatedProducts-title primary-border-color-after global-primary dark-primary">推薦產品<a style="display: inline-block;margin-left:5px;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h3>'
          //               )
          //               $('.ProductDetail-relatedProducts').append(
          //                   '<div class="ProductDetail-relatedProducts-list" id="rosetta-query-container" style="position:relative;"></div>'
          //               )
          //               container = $('#rosetta-query-container')
          //               let limits = 4
          //               let iterator = 0
          //               let haystack = []
          //               lists.forEach(list => {
          //                   // console.log('show list', list)
          //                   const { property, item } = list
          //                   if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
          //                       if (rosetta.ab === 'on' || rosetta.ab === '') {
          //                           if (
          //                               property.name.indexOf('fingerPrint') > -1 ||
          //                               isNil(property.local_id) ||
          //                               isNil(property.price)
          //                           ) {
          //                               return
          //                           }
          //                           let showPrice =
          //                               typeof property.sale_price !== 'undefined'
          //                                   ? `<div class="price-sale price ">
          //       NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
          //       NT$${property.price}</div>`
          //                                   : `<div class="global-primary dark-primary price">
          //       NT$${property.price}
          //       </div>`
          //                           container.append(
          //                               `
          //       <div class="product-item">
          //         <div class="ng-scope">
          //           <a href="${property.link}" class="quick-cart-item js-quick-cart-item" target="_blank">
          //             <div class="boxify-image-wrapper js-quick-boxify-image">
          //               <div class="boxify-image center-contain " style="background-image:url(${property.image_link})"></div>
          //             </div>
          //             <div class="info-box">
          //               <div class="info-box-inner-wrapper">
          //                 <div class="title text-primary-color">${property.name}</div>
          //                 <div class="quick-cart-price">
          //                   ${showPrice}
          //                 </div>
          //               </div>
          //             </div>
          //           </a>
          //         </div>
          //       </div>
          //       `
          //                           )
          //                       }
          //                       haystack.push(item)
          //                       iterator += 1
          //                   }
          //               })
          //               // console.log('query_id, iterator, haystack', query_id, iterator, haystack)
          //               rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
          //               rosetta.bindNormalList()
          //           }
          //       }
          //   },
    //         doUISpecial_FunHouse(lists, query_id) {
    //             let path = rosetta.getPath()
    //             let parsePath = path.split('/')
    //             if (path === '/') {
    //                 let container

    //                 if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                     const items = $('.Grid-row-wrapper')

    //                     $.each($(items), function(i, val) {
    //                         if (
    //                             $(val)
    //                                 .find('span')
    //                                 .text()
    //                                 .indexOf('BRAND') > -1
    //                         ) {
    //                             $(
    //                                 '<div class="Grid-row-wrapper rosetta"><div class="Grid-row"><div class="Grid-item"><p class="global-primary dark-primary section-title rosetta-title">You May Also Like<a class="quick-cart-item" style="margin-left:5px;display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div></div></div>'
    //                             ).insertBefore($(val))
    //                         }
    //                     })

    //                     $(
    //                         '<div class="Grid-row"><div class="Grid-item"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div></div></div>'
    //                     ).insertAfter('.rosetta-title')
    //                     container = $('#rosetta-query-container')
    //                     let limits = 4
    //                     let iterator = 0
    //                     let haystack = []
    //                     lists.forEach(list => {
    //                         const { property, item } = list
    //                         if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
    //                             if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                                 if (
    //                                     property.name.indexOf('fingerPrint') > -1 ||
    //                                     isNil(property.local_id) ||
    //                                     isNil(property.price)
    //                                 ) {
    //                                     return
    //                                 }
    //                                 let showPrice =
    //                                     typeof property.sale_price !== 'undefined'
    //                                         ? `<div class="price-sale price ">
    //           NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
    //           NT$${property.price}</div>`
    //                                         : `<div class="global-primary dark-primary price">
    //           NT$${property.price}
    //     </div>`
    //                                 container.append(
    //                                     `
    //         <div class="product-item col-xs-6 col-md-3">
    //           <div>
    //             <a href="${property.link}" class="quick-cart-item" target="_blank">
    //               <div class="boxify-image-wrapper">
    //                 <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
    //                 </div>
    //               </div>
    //               <div class="info-box">
    //                 <div class="info-box-inner-wrapper">
    //                   <div class="title text-primary-color title-container ellipsis" data-max-height="45">
    //                     ${property.name}
    //                   </div>
    //                   <div class="quick-cart-price">
    //                     ${showPrice}
    //                   </div>
    //                 </div>
    //               </div>
    //             </a>
    //           </div>
    //         </div>
    //         `
    //                                 )
    //                             }
    //                             haystack.push(item)
    //                             iterator += 1
    //                         }
    //                     })
    //                     rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
    //                     rosetta.bindList()
    //                 }
    //             } else if (parsePath[1] === 'categories') {
    //                 let container
    //                 if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                     $(
    //                         '<h3 class="ProductDetail-relatedProducts-title primary-border-color-after global-primary dark-primary">You May Also Like<a style="display: inline-block;vertical-align: top;padding-top: 3px;margin-left:5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;"></a></h3>'
    //                     ).insertAfter($('.ProductList-info'))
    //                     $(
    //                         '<div class="ProductDetail-relatedProducts-list" id="rosetta-query-container" style="position:relative;"></div>'
    //                     ).insertAfter($('.ProductDetail-relatedProducts-title'))

    //                     container = $('#rosetta-query-container')
    //                     let limits = 4
    //                     let iterator = 0
    //                     let haystack = []
    //                     lists.forEach(list => {
    //                         // console.log('show list', list)
    //                         const { property, item } = list
    //                         if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
    //                             if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                                 if (
    //                                     property.name.indexOf('fingerPrint') > -1 ||
    //                                     isNil(property.local_id) ||
    //                                     isNil(property.price)
    //                                 ) {
    //                                     return
    //                                 }
    //                                 let showPrice =
    //                                     typeof property.sale_price !== 'undefined'
    //                                         ? `<div class="price-sale price ">
    //     NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
    //     NT$${property.price}</div>`
    //                                         : `<div class="global-primary dark-primary price">
    //     NT$${property.price}
    //     </div>`
    //                                 container.append(
    //                                     `
    //         <div class="product-item">
    //           <div class="ng-scope">
    //             <a href="${property.link}" class="quick-cart-item js-quick-cart-item" target="_blank">
    //               <div class="boxify-image-wrapper js-quick-boxify-image">
    //                 <div class="boxify-image center-contain " style="background-image:url(${property.image_link})"></div>
    //               </div>
    //               <div class="info-box">
    //                 <div class="info-box-inner-wrapper">
    //                   <div class="title text-primary-color">${property.name}</div>
    //                   <div class="quick-cart-price">
    //                     ${showPrice}
    //                   </div>
    //                 </div>
    //               </div>
    //             </a>
    //           </div>
    //         </div>
    //         `
    //                                 )
    //                             }
    //                             haystack.push(item)
    //                             iterator += 1
    //                         }
    //                     })
    //                     // console.log('query_id, iterator, haystack', query_id, iterator, haystack)
    //                     rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
    //                     rosetta.bindNormalList()
    //                 }
    //             } else if (parsePath[1] === 'products') {
    //                 if (typeof parsePath[2] !== 'undefined') {
    //                     let container
    //                     if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                         if (rosetta.override && lists) {
    //                             $('.ProductDetail-relatedProducts-list')
    //                                 .prev('h3')
    //                                 .remove()
    //                             $('.ProductDetail-relatedProducts-list').remove()
    //                         }
    //                         $('.ProductDetail-relatedProducts').append(
    //                             '<h3 class="ProductDetail-relatedProducts-title primary-border-color-after global-primary dark-primary">You May Also Like<a style="display: inline-block;margin-left:5px;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h3>'
    //                         )
    //                         $('.ProductDetail-relatedProducts').append(
    //                             '<div class="ProductDetail-relatedProducts-list" id="rosetta-query-container" style="position:relative;"></div>'
    //                         )
    //                         container = $('#rosetta-query-container')
    //                         let limits = 4
    //                         let iterator = 0
    //                         let haystack = []
    //                         lists.forEach(list => {
    //                             // console.log('show list', list)
    //                             const { property, item } = list
    //                             if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
    //                                 if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                                     if (
    //                                         property.name.indexOf('fingerPrint') > -1 ||
    //                                         isNil(property.local_id) ||
    //                                         isNil(property.price)
    //                                     ) {
    //                                         return
    //                                     }
    //                                     let showPrice =
    //                                         typeof property.sale_price !== 'undefined'
    //                                             ? `<div class="price-sale price ">
    //           NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
    //           NT$${property.price}</div>`
    //                                             : `<div class="global-primary dark-primary price">
    //           NT$${property.price}
    //           </div>`
    //                                     container.append(
    //                                         `
    //           <div class="product-item">
    //             <div class="ng-scope">
    //               <a href="${property.link}" class="quick-cart-item js-quick-cart-item" target="_blank">
    //                 <div class="boxify-image-wrapper js-quick-boxify-image">
    //                   <div class="boxify-image center-contain " style="background-image:url(${property.image_link})"></div>
    //                 </div>
    //                 <div class="info-box">
    //                   <div class="info-box-inner-wrapper">
    //                     <div class="title text-primary-color">${property.name}</div>
    //                     <div class="quick-cart-price">
    //                       ${showPrice}
    //                     </div>
    //                   </div>
    //                 </div>
    //               </a>
    //             </div>
    //           </div>
    //           `
    //                                     )
    //                                 }
    //                                 haystack.push(item)
    //                                 iterator += 1
    //                             }
    //                         })
    //                         // console.log('query_id, iterator, haystack', query_id, iterator, haystack)
    //                         rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
    //                         rosetta.bindNormalList()
    //                     }
    //                 }
    //             }
    //         },
    //         doUISpecial_YohoPower(lists, query_id) {
    //             let path = rosetta.getPath()
    //             let parsePath = path.split('/')
    //             if (path === '/') {
    //                 let container
    //                 // <span style="color: #777;font-weight: lighter;text-transform: lowercase;">( powered by <span style="text-transform: none;">Rosetta.ai</span> )</span>
    //                 if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                     if ($('.yield-wrapper .global-primary').eq(6).length === 0) {
    //                         throw new UserError('YohoPower index dom change')
    //                     }
    //                     $(`<div class="container global-primary rosetta-container">
    //                         <div class="container-md-height" style="height: 100%; table-layout: fixed; width: 100%; margin-bottom: 2%; ">
    //                         <div class="row row-md-height" style="height: 100%;">
    //                             <div id="page-item-5cf5df7b7345220020862c2d" class="item grid-text-item
    //                                 col-xs-12
    //                                 col-md-12
    //                                 col-md-height
    //                                 " style="vertical-align: top; height: 100%;">
    //                             <div style="height: 100%;">
    //                                 <div class="box-info " >
    //                                     <div class="description" ng-non-bindable=""><p class="global-primary dark-primary section-title">推薦商品<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div>
    //                                 </div>
    //                             </div>
    //                             </div>
    //                         </div>
    //                         </div>
    //                     </div>`).insertAfter($('.yield-wrapper .global-primary').eq(6))

    //                     $(`<div class="container global-primary"><div class="Grid-item"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div></div>
    //                   </div>`).insertAfter('.rosetta-container')

    //                     container = $('#rosetta-query-container')
    //                     let limits = 4
    //                     let iterator = 0
    //                     let haystack = []
    //                     lists.forEach(list => {
    //                         const { property, item } = list
    //                         if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
    //                             if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                                 if (
    //                                     property.name.indexOf('fingerPrint') > -1 ||
    //                                     isNil(property.local_id) ||
    //                                     isNil(property.price)
    //                                 ) {
    //                                     return
    //                                 }
    //                                 let showPrice =
    //                                     typeof property.sale_price !== 'undefined'
    //                                         ? `<div class="price-sale price ">
    //             NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
    //             NT$${property.price}</div>`
    //                                         : `<div class="global-primary dark-primary price">
    //             NT$${property.price}
    //       </div>`
    //                                 container.append(`
    //                                 <div class="product-item col-xs-6 col-md-3">
    //                                   <div>
    //                                     <a href="${property.link}" class="quick-cart-item" target="_blank">
    //                                       <div class="boxify-image-wrapper">
    //                                         <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
    //                                         </div>
    //                                       </div>
    //                                       <div class="info-box">
    //                                         <div class="info-box-inner-wrapper">
    //                                           <div class="title text-primary-color title-container ellipsis" data-max-height="45">
    //                                           ${property.name}
    //                                           </div>
    //                                           <div class="quick-cart-price">
    //                                           ${showPrice}
    //                                           </div>
    //                                         </div>
    //                                       </div>
    //                                     </a>
    //                                   </div>
    //                                 </div>
    //           `)
    //                             }
    //                             haystack.push(item)
    //                             iterator += 1
    //                         }
    //                     })
    //                     rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
    //                     rosetta.bindList()
    //                 }
    //             } else if (parsePath[1] === 'categories') {
    //                 let container
    //                 if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                     if ($('.product-list-container .page-bar') === 0) {
    //                         throw new UserError('yohopower category dom change')
    //                     }
    //                     $(
    //                         '<h2 class="global-primary dark-primary">你可能喜歡 <a style="display: inline-block;vertical-align: top;padding-top: 2px;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h2>'
    //                     ).insertAfter('.product-list-container .page-bar')
    //                     $(
    //                         '<div id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
    //                     ).insertAfter('h2.global-primary.dark-primary')

    //                     container = $('#rosetta-query-container').children()
    //                     let limits = 4
    //                     let iterator = 0
    //                     let haystack = []
    //                     // console.log('lists',lists)
    //                     lists.forEach(list => {
    //                         const { property, item } = list
    //                         if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
    //                             if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                                 if (
    //                                     property.name.indexOf('fingerPrint') > -1 ||
    //                                     isNil(property.local_id) ||
    //                                     isNil(property.price)
    //                                 ) {
    //                                     return
    //                                 }
    //                                 let showPrice =
    //                                     typeof property.sale_price !== 'undefined'
    //                                         ? `<div class = "global-primary dark-primary price price-crossed ">
    //           NT$${property.price}</div>
    //           <div class="price-sale price ">
    //           NT$${property.sale_price}
    //           </div></div>`
    //                                         : `<div class="global-primary dark-primary price">
    //           NT$${property.price}
    //           </div>`
    //                                 container.append(
    //                                     `
    //             <li class="boxify-item product-item">
    //               <a href="${property.link}" class="quick-cart-item">
    //                 <div class="boxify-image-wrapper">
    //                   <div class="boxify-image center-contain sl-lazy-image " style="background-image:url(${property.image_link})"></div>
    //                 </div>
    //                 <div class="info-box" style="">
    //                   <div class="info-box-inner-wrapper">
    //                   <div class="title text-primary-color title-container ellipsis " ng-non-bindable="" style="overflow-wrap: break-word;">${property.name}</div>
    //                     ${showPrice}
    //                   </div>
    //                 </div>
    //               </a>
    //             </li>
    //             `
    //                                 )
    //                             }
    //                             haystack.push(item)
    //                             iterator += 1
    //                         }
    //                     })
    //                     rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
    //                     rosetta.bindNormalList()
    //                 }
    //             } else if (parsePath[1] === 'products') {
    //                 // console.log('render商品頁')
    //                 let container
    //                 if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                     if (rosetta.override && lists) {
    //                         // 如果是複寫相關商品，就移除相關商品 DOM
    //                         $('.related-products')
    //                             .parent()
    //                             .prev('h2')
    //                             .remove()
    //                         $('.related-products')
    //                             .parent()
    //                             .remove()
    //                     }
    //                     if ($('.fb-comments').length === 0 && $('.product-detail-container').length === 0) {
    //                         throw new UserError('normal products dom change')
    //                     }
    //                     if ($('.fb-comments').length > 0) {
    //                         $(
    //                             '<h2 class="global-primary dark-primary rosetta-primary">推薦產品 <a style="display: inline-block;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h2>'
    //                         ).insertBefore($('.fb-comments'))
    //                         // console.log('.global-primary.dark-primary',$('.global-primary.dark-primary'))
    //                         $(
    //                             '<div class="row" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
    //                         ).insertAfter($('h2.rosetta-primary'))
    //                     } else if ($('.product-detail-container').length > 0) {
    //                         $('.product-detail-container').append(
    //                             '<h2 class="global-primary dark-primary">推薦產品 <a style="display: inline-block;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h2>'
    //                         )
    //                         $('.product-detail-container').append(
    //                             '<div class="row" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
    //                         )
    //                     }
    //                     container = $('#rosetta-query-container').children()
    //                     let limits = 4
    //                     let iterator = 0
    //                     let haystack = []
    //                     // console.log('lists',lists)
    //                     lists.forEach(list => {
    //                         const { property, item } = list
    //                         if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
    //                             if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                                 if (
    //                                     property.name.indexOf('fingerPrint') > -1 ||
    //                                     isNil(property.local_id) ||
    //                                     isNil(property.price)
    //                                 ) {
    //                                     return
    //                                 }
    //                                 let showPrice =
    //                                     typeof property.sale_price !== 'undefined'
    //                                         ? `<div class = "global-primary dark-primary price price-crossed ">
    //       NT$${property.price}</div>
    //       <div class="price-sale price ">
    //       NT$${property.sale_price}
    //       </div></div>`
    //                                         : `<div class="global-primary dark-primary price">
    //       NT$${property.price}
    //       </div>`

    //                                 container.append(
    //                                     `
    //         <li class="boxify-item product-item">
    //           <a href="${property.link}">
    //             <div class="boxify-image-wrapper">
    //               <div class="boxify-image center-contain sl-lazy-image " style="background-image:url(${property.image_link})"></div>
    //             </div>
    //             <div class="info-box" style="">
    //               <div class="info-box-inner-wrapper">
    //               <div class="title text-primary-color title-container ellipsis " ng-non-bindable="" style="overflow-wrap: break-word;">${property.name}</div>
    //               ${showPrice}
    //               </div>
    //             </div>
    //           </a>
    //         </li>
    //         `
    //                                 )
    //                             }
    //                             haystack.push(item)
    //                             iterator += 1
    //                         }
    //                     })
    //                     rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
    //                     rosetta.bindNormalList()
    //                 }
    //             }
    //         },
    //         doUISpecial_Hlolo(lists, query_id) {
    //             let path = rosetta.getPath()
    //             let parsePath = path.split('/')
    //             if (path === '/') {
    //                 let container
    //                 if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                     const items = $('.Grid-row-wrapper')
    //                     let target
    //                     $.each($(items), function(i, val) {
    //                         if (
    //                             $(val)
    //                                 .find('h2')
    //                                 .text()
    //                                 .indexOf('時尚塑身系') > -1
    //                         ) {
    //                             $(`<div class="Grid-row-wrapper rosetta-wrapper">
    //                             <div class="Grid-row">
    //                                 <div class="Grid-item">
    //                                     <div class="Grid-item-title primary-border-color-after">
    //                                         <p class="global-primary dark-primary section-title">
    //                                             推薦商品<a class="quick-cart-item"
    //                                                 style="display: inline-block;vertical-align: top;padding-top: 2px;"
    //                                                 href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button"
    //                                                 target="_blank"
    //                                                 ><img
    //                                                     class="rosetta-logo"
    //                                                     src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png"
    //                                                     style="width: 70px;"
    //                                             /></a>
    //                                         </p>
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>`).insertBefore($(val))
    //                             target = $(val)
    //                             if ($(val).length === 0) {
    //                                 throw new UserError('hlolo index dom change')
    //                             }
    //                         }
    //                     })

    //                     $(`<div class="Grid-row">
    //                     <div class="Grid-item">
    //                         <div
    //                             class="page-item-products-container ng-scope"
    //                             page-item-products=""
    //                             items-per-page="4"
    //                             col-class="col-md-3"
    //                             is-quick-cart="true"
    //                             open-link-in-new-tab="true"
    //                         >
    //                             <div id="rosetta-query-container" class="product-items-container quick-cart-container"></div></div>
    //                             </div></div>`).insertAfter('.rosetta-wrapper')

    //                     container = $('#rosetta-query-container')
    //                     let limits = 4
    //                     let iterator = 0
    //                     let haystack = []
    //                     lists.forEach(list => {
    //                         const { property, item } = list
    //                         if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
    //                             if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                                 if (
    //                                     property.name.indexOf('fingerPrint') > -1 ||
    //                                     isNil(property.local_id) ||
    //                                     isNil(property.price)
    //                                 ) {
    //                                     return
    //                                 }
    //                                 let showPrice =
    //                                     typeof property.sale_price !== 'undefined'
    //                                         ? `<div class="price-sale price sl-price primary-color-price">NT$${property.sale_price}</div>
    // <div class="global-primary dark-primary price sl-price price-crossed">NT$${property.price}</div>`
    //                                         : `<div class="global-primary dark-primary price sl-price">NT$${property.price}</div>`

    //                                 container.append(`<div class="product-item col-xs-6 col-md-3 ng-isolate-scope">
    //                                 <product-item ng-class="{'quick-cart-mobile': isMobileTabletWidth()}" class="ng-scope quick-cart-mobile">
    //                                     <a
    //                                         href="${property.link}"
    //                                         target="_blank"
    //                                         class="quick-cart-item js-quick-cart-item ng-isolate-scope"
    //                                     >
    //                                         <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
    //                                             <div
    //                                                 class="boxify-image js-boxify-image center-contain sl-lazy-image "
    //                                                 style="background-image:url(${property.image_link})"
    //                                             ></div>
    //                                             <div
    //                                                 class="boxify-image js-boxify-image center-contain sl-lazy-image  second-image"
    //                                                 style="background-image:url(${property.image_link})"
    //                                             ></div>
    //                                         </div>
    //                                         <div class="info-box">
    //                                             <div class="info-box-inner-wrapper">
    //                                                 <div class="title text-primary-color">
    //                                                 ${property.name}
    //                                                 </div>
    //                                                 <div class="quick-cart-price">
    //                                                     ${showPrice}
    //                                                 </div>
    //                                             </div>
    //                                         </div>
    //                                     </a>
    //                                 </product-item>
    //                             </div>

    //           `)
    //                             }
    //                             haystack.push(item)
    //                             iterator += 1
    //                         }
    //                     })
    //                     rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
    //                     rosetta.bindList()
    //                 }
    //             } else if (parsePath[1] === 'categories') {
    //                 let container
    //                 if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                     if ($('.block-inner .ProductList-info').length === 0) {
    //                         throw new UserError('hlolo category dom change')
    //                     }
    //                     $(
    //                         '<h3 class="global-primary dark-primary">你可能喜歡 <a style="display: inline-block;vertical-align: top;padding-top: 2px;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h3>'
    //                     ).insertAfter('.block-inner .ProductList-info')
    //                     $(
    //                         '<div id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
    //                     ).insertAfter('h3.global-primary.dark-primary')

    //                     container = $('#rosetta-query-container').children()
    //                     let limits = 4
    //                     let iterator = 0
    //                     let haystack = []
    //                     // console.log('lists',lists)
    //                     lists.forEach(list => {
    //                         const { property, item } = list
    //                         if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
    //                             if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                                 if (
    //                                     property.name.indexOf('fingerPrint') > -1 ||
    //                                     isNil(property.local_id) ||
    //                                     isNil(property.price)
    //                                 ) {
    //                                     return
    //                                 }
    //                                 let showPrice =
    //                                     typeof property.sale_price !== 'undefined'
    //                                         ? `<div class = "global-primary dark-primary price price-crossed ">
    //           NT$${property.price}</div>
    //           <div class="price-sale price ">
    //           NT$${property.sale_price}
    //           </div></div>`
    //                                         : `<div class="global-primary dark-primary price">
    //           NT$${property.price}
    //           </div>`
    //                                 container.append(
    //                                     `
    //             <li class="boxify-item product-item">
    //               <a href="${property.link}" class="quick-cart-item">
    //                 <div class="boxify-image-wrapper">
    //                   <div class="boxify-image center-contain sl-lazy-image " style="background-image:url(${property.image_link})"></div>
    //                 </div>
    //                 <div class="info-box" style="">
    //                   <div class="info-box-inner-wrapper">
    //                   <div class="title text-primary-color title-container ellipsis " ng-non-bindable="" style="overflow-wrap: break-word;">${property.name}</div>
    //                     ${showPrice}
    //                   </div>
    //                 </div>
    //               </a>
    //             </li>
    //             `
    //                                 )
    //                             }
    //                             haystack.push(item)
    //                             iterator += 1
    //                         }
    //                     })
    //                     rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
    //                     rosetta.bindNormalList()
    //                 }
    //             } else if (parsePath[1] === 'products') {
    //                 if (typeof parsePath[2] !== 'undefined') {
    //                     let container
    //                     if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                         if ($('.ProductDetail-relatedProducts').length === 0) {
    //                             throw new UserError('hlolo products dom change')
    //                         }
    //                         if (rosetta.override && lists) {
    //                             $('.ProductDetail-relatedProducts').empty()
    //                         }
    //                         // <span style="color: #777;font-weight: lighter;text-transform: lowercase;">( powered by <span style="text-transform: none;">Rosetta.ai</span> )</span>
    //                         $('.ProductDetail-relatedProducts').append(
    //                             `<h3 class="ProductDetail-relatedProducts-title primary-border-color-after">
    //                             推薦產品
    //                             <a
    //                                 style="display: inline-block;margin-left: 5px;"
    //                                 href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button"
    //                                 target="_blank"
    //                                 ><img
    //                                     class="rosetta-logo"
    //                                     src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png"
    //                                     style="width: 70px;vertical-align: top;padding-top: 2px;"
    //                             /></a>
    //                         </h3>`
    //                         )

    //                         $('.ProductDetail-relatedProducts').append(
    //                             ` <div id="rosetta-query-container" class="ProductDetail-relatedProducts-list">
    //                            </div>`
    //                         )
    //                         container = $('#rosetta-query-container')
    //                         let limits = 4
    //                         let iterator = 0
    //                         let haystack = []
    //                         lists.forEach(list => {
    //                             // console.log('show list', list)
    //                             const { property, item } = list
    //                             if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
    //                                 if (rosetta.ab === 'on' || rosetta.ab === '') {
    //                                     if (
    //                                         property.name.indexOf('fingerPrint') > -1 ||
    //                                         isNil(property.local_id) ||
    //                                         isNil(property.price)
    //                                     ) {
    //                                         return
    //                                     }
    //                                     let showPrice =
    //                                         typeof property.sale_price !== 'undefined'
    //                                             ? `<div class="price-sale price ">
    //             NT$${property.sale_price}</div><div class = "global-primary dark-primary price price-crossed ">
    //             NT$${property.price}</div>`
    //                                             : `<div class="global-primary dark-primary price">
    //             NT$${property.price}
    //             </div>`
    //                                     container.append(
    //                                         `
    //                                         <div class="product-item">
    //                                         <product-item ng-class="{'quick-cart-mobile': isMobileTabletWidth()}" class="ng-scope">
    //                                             <a href="${property.link}"  class="quick-cart-item js-quick-cart-item ng-isolate-scope">
    //                                              <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
    //                                              <div class="boxify-image js-boxify-image center-contain sl-lazy-image " style="background-image:url(${property.image_link})">
    //                                              </div>
    //                                              <div class="boxify-image js-boxify-image center-contain sl-lazy-image  second-image" style="background-image:url(${property.image_link})">
    //                                              </div>
    //                                              </div>
    //                                              <div class="info-box">
    //                                              <div class="info-box-inner-wrapper">
    //                                              <div class="title text-primary-color">${property.name}</div>
    //                                              <div class="quick-cart-price">
    //                                              ${showPrice}
    //                                               </div>
    //                                               </div>
    //                                               </div>
    //                                               </a>
    //                                         </product-item>
    //                                         </div>
    //             `
    //                                     )
    //                                 }
    //                                 haystack.push(item)
    //                                 iterator += 1
    //                             }
    //                         })
    //                         // console.log('query_id, iterator, haystack', query_id, iterator, haystack)
    //                         rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
    //                         rosetta.bindNormalList()
    //                     }

    //                     // rosetta.bindList()
    //                 }
    //             }
    //         },
            doUINormal(lists, query_id) {
                let path = rosetta.getPath()
                let parsePath = path.split('/')
                if (path === '/') {
                    let febforestIndex = window.location.href.indexOf('febforest') > -1
                    let nextyogataiwanIndex = window.location.href.indexOf('nextyogataiwan') > -1
                    let pgmall = window.location.href.indexOf('pgmall') > -1
                    let injoymall = window.location.href.indexOf('injoymall') > -1
                    let leap = window.location.href.indexOf('leap-sports') > -1
                    let tshop = window.location.href.indexOf('tshop-tshop') > -1
                    let jwell = window.location.href.indexOf('j-well') > -1
                    let sothatsme = window.location.href.indexOf('sothatsme') > -1
                    let container

                    if (sothatsme) {
                        $(
                            '<div class="container global-primary"><div class="container-md-height" style="height: 100%; table-layout: fixed; width: 100%; margin-bottom: 2%;"><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%; text-align: center;"><p class="global-primary dark-primary section-title" style="margin: auto; color: #666; font-size: x-large; font-weight: bold;">你可能會喜歡&nbsp;<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div></div><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%;"><div style="height: 100%;"><div class="box-info"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div></div></div></div></div></div>'
                        ).insertAfter(
                            $('.CustomPage').children('.Grid-row-wrapper').eq(1)
                        )
                        container = $('#rosetta-query-container')
                        let limits = 4
                        let iterator = 0
                        let haystack = []
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class = "global-primary dark-primary price price-crossed">
              NT$${property.price}</div>
              <div class="price-sale price ">
              NT$${property.sale_price}
              </div></div>`
                                            : `<div class="global-primary dark-primary price">
              NT$${property.price}
              </div>`

                                    container.append(
                                        `
                <div class="product-item col-xs-6 col-md-3" data-item-type="${property.type}">
                  <a href="${property.link}" class="quick-cart-item">
                    <div class="boxify-image-wrapper">
                      <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
                      </div>
                    </div>
                    <div class="info-box">
                      <div class="info-box-inner-wrapper">
                        <div class="title text-primary-color title-container ellipsis" data-max-height="45">
                          ${property.name}
                        </div>
                        <div class="quick-cart-price">
                          ${showPrice}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindList()
                    } else if (jwell) {
                        if (rosetta.ab === 'on' || rosetta.ab === '') {
                            $(
                                '<div class="container global-primary"><div class="container-md-height" style="height: 100%; table-layout: fixed; width: 100%; margin-bottom: 2%;"><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%; text-align: center;"><p class="global-primary dark-primary section-title" style="margin: auto; color: #666; font-size: x-large; font-weight: bold;">你可能會喜歡&nbsp;<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div></div><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%;"><div style="height: 100%;"><div class="box-info"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div></div></div></div></div></div>'
                            ).insertAfter(
                                $('.CustomPage').children('.Grid-row-wrapper').eq(3)
                            )
                            container = $('#rosetta-query-container')
                        }
                        let limits = 4
                        let iterator = 0
                        let haystack = []
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class = "global-primary dark-primary price price-crossed">
              NT$${property.price}</div>
              <div class="price-sale price ">
              NT$${property.sale_price}
              </div></div>`
                                            : `<div class="global-primary dark-primary price">
              NT$${property.price}
              </div>`

                                    container.append(
                                        `
                <div class="product-item col-xs-6 col-md-3" data-item-type="${property.type}">
                  <a href="${property.link}" class="quick-cart-item">
                    <div class="boxify-image-wrapper">
                      <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
                      </div>
                    </div>
                    <div class="info-box">
                      <div class="info-box-inner-wrapper">
                        <div class="title text-primary-color title-container ellipsis" data-max-height="45">
                          ${property.name}
                        </div>
                        <div class="quick-cart-price">
                          ${showPrice}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindList()
                    } else if (tshop) {
                        $(
                            '<div class="container global-primary"><div class="container-md-height" style="height: 100%; table-layout: fixed; width: 100%; margin-bottom: 2%;"><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%; text-align: center;"><p class="global-primary dark-primary section-title" style="margin: auto; color: #666; font-size: x-large; font-weight: bold;">你可能會喜歡&nbsp;<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div></div><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%;"><div style="height: 100%;"><div class="box-info"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div></div></div></div></div></div>'
                        ).insertAfter(
                            $('.custom-page').children('.global-primary').eq(1)
                        )
                        container = $('#rosetta-query-container')
                        let limits = 4
                        let iterator = 0
                        let haystack = []
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class = "global-primary dark-primary price price-crossed">
              NT$${property.price}</div>
              <div class="price-sale price ">
              NT$${property.sale_price}
              </div></div>`
                                            : `<div class="global-primary dark-primary price">
              NT$${property.price}
              </div>`

                                    container.append(
                                        `
                <div class="product-item col-xs-6 col-md-3" data-item-type="${property.type}">
                  <a href="${property.link}" class="quick-cart-item">
                    <div class="boxify-image-wrapper">
                      <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
                      </div>
                    </div>
                    <div class="info-box">
                      <div class="info-box-inner-wrapper">
                        <div class="title text-primary-color title-container ellipsis" data-max-height="45">
                          ${property.name}
                        </div>
                        <div class="quick-cart-price">
                          ${showPrice}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindList()
                    } else if (leap) {
                        $(
                            '<div class="container global-primary" style="margin-top: 60px;"><div class="container-md-height" style="height: 100%; table-layout: fixed; width: 100%; margin-bottom: 2%;"><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%; text-align: center;"><p class="global-primary dark-primary section-title" style="margin: auto; color: #666; font-size: x-large; font-weight: bold;">你可能會喜歡&nbsp;<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div></div><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%;"><div style="height: 100%;"><div class="box-info"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div></div></div></div></div></div>'
                        ).insertAfter(
                            $('.custom-page').children('.global-primary').eq(6)
                        )
                        container = $('#rosetta-query-container')
                        let limits = 4
                        let iterator = 0
                        let haystack = []
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class = "global-primary dark-primary price price-crossed">
              NT$${property.price}</div>
              <div class="price-sale price ">
              NT$${property.sale_price}
              </div></div>`
                                            : `<div class="global-primary dark-primary price">
              NT$${property.price}
              </div>`

                                    container.append(
                                        `
                <div class="product-item col-xs-6 col-md-3" data-item-type="${property.type}">
                  <a href="${property.link}" class="quick-cart-item">
                    <div class="boxify-image-wrapper">
                      <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
                      </div>
                    </div>
                    <div class="info-box">
                      <div class="info-box-inner-wrapper">
                        <div class="title text-primary-color title-container ellipsis" data-max-height="45">
                          ${property.name}
                        </div>
                        <div class="quick-cart-price">
                          ${showPrice}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindList()
                    } else if (injoymall) {
                        $(
                            '<div class="container global-primary"><div class="container-md-height" style="height: 100%; table-layout: fixed; width: 100%; margin-bottom: 2%;"><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%; text-align: center; font-weight: bolder; font-size: x-large;"><p class="global-primary dark-primary section-title">猜你可能喜歡</p></div></div><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%;"><div style="height: 100%;"><div class="box-info"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div></div></div></div></div></div>'
                        ).insertAfter(
                            $('.custom-page').children('.global-primary').eq(1)
                        )
                        container = $('#rosetta-query-container')
                        let limits = 4
                        let iterator = 0
                        let haystack = []
                        // console.log('lists',lists)
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    // console.log('list.name',list.name)
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class = "global-primary dark-primary price price-crossed ">
              NT$${property.price}</div>
              <div class="price-sale price ">
              NT$${property.sale_price}
              </div></div>`
                                            : `<div class="global-primary dark-primary price">
              NT$${property.price}
              </div>`

                                    container.append(
                                        `
                <div class="product-item col-xs-6 col-md-3" data-item-type="${property.type}">
                  <a href="${property.link}" class="quick-cart-item">
                    <div class="boxify-image-wrapper">
                      <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
                      </div>
                    </div>
                    <div class="info-box">
                      <div class="info-box-inner-wrapper">
                        <div class="title text-primary-color title-container ellipsis" data-max-height="45">
                          ${property.name}
                        </div>
                        <div class="quick-cart-price">
                          ${showPrice}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindList()
                    } else if (pgmall) {
                        // <span style="color: #777;font-weight: lighter;text-transform: lowercase;">( powered by <span style="text-transform: none;">Rosetta.ai</span> )</span>
                        if (
                            $('.page-item-products-container')
                                .first()
                                .parent().length === 0
                        ) {
                            throw new UserError('normal index dom change')
                        }

                        $(
                            '<div class="container global-primary"><div class="container-md-height" style="height: 100%; table-layout: fixed; width: 100%; margin-bottom: 2%;"><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%; text-align: center;"><p class="global-primary dark-primary section-title" style="margin: auto; color: #666; font-size: x-large; font-weight: bold;">你可能會喜歡<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div></div><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%;"><div style="height: 100%;"><div class="box-info"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div></div></div></div></div></div>'
                        ).insertAfter(
                            $('.custom-page').children('.container-full-width').eq(1)
                        )
                        container = $('#rosetta-query-container')
                        let limits = 4
                        let iterator = 0
                        let haystack = []
                        // console.log('lists',lists)
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    // console.log('list.name',list.name)
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class = "global-primary dark-primary price price-crossed ">
              NT$${property.price}</div>
              <div class="price-sale price ">
              NT$${property.sale_price}
              </div></div>`
                                            : `<div class="global-primary dark-primary price">
              NT$${property.price}
              </div>`

                                    container.append(
                                        `
                <div class="product-item col-xs-6 col-md-3" data-item-type="${property.type}">
                  <a href="${property.link}" class="quick-cart-item">
                    <div class="boxify-image-wrapper">
                      <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
                      </div>
                    </div>
                    <div class="info-box">
                      <div class="info-box-inner-wrapper">
                        <div class="title text-primary-color title-container ellipsis" data-max-height="45">
                          ${property.name}
                        </div>
                        <div class="quick-cart-price">
                          ${showPrice}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindList()
                    } else if (febforestIndex) {
                        if (rosetta.ab === 'on' && rosetta.override) {
                            $('.page-item-products-container')
                                .parent()
                                .addClass('rosetta-box-info')
                            $('.page-item-products-container')
                                .parent()
                                .empty()
                        }
                        if (rosetta.ab === 'on' || rosetta.ab === '') {
                            // <span style="color: #777;font-weight: lighter;text-transform: lowercase;">( powered by <span style="text-transform: none;">Rosetta.ai</span> )</span>
                            $(
                                '<p class="global-primary dark-primary section-title rosetta-title">推薦商品<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p>'
                            ).appendTo($('.rosetta-box-info'))
                            $(
                                '<div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div>'
                            ).insertAfter($('.rosetta-title'))
                            container = $('#rosetta-query-container')
                        }
                        let limits = 4
                        let iterator = 0
                        let haystack = []
                        // console.log('lists',lists)
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    // console.log('list.name',list.name)
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class = "global-primary dark-primary price price-crossed ">
              NT$${property.price}</div>
              <div class="price-sale price ">
              NT$${property.sale_price}
              </div></div>`
                                            : `<div class="global-primary dark-primary price">
              NT$${property.price}
              </div>`

                                    container.append(
                                        `
                <div class="product-item col-xs-6 col-md-3" data-item-type="${property.type}">
                  <a href="${property.link}" class="quick-cart-item">
                    <div class="boxify-image-wrapper">
                      <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
                      </div>
                    </div>
                    <div class="info-box">
                      <div class="info-box-inner-wrapper">
                        <div class="title text-primary-color title-container ellipsis" data-max-height="45">
                          ${property.name}
                        </div>
                        <div class="quick-cart-price">
                          ${showPrice}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindList()
                    } else if (nextyogataiwanIndex) {
                        if ($('.container.global-primary').eq(2).length === 0) {
                            throw new UserError('nextyogataiwan index dom change')
                        }
                        if (rosetta.ab === 'on' || rosetta.ab === '') {
                            $(
                                `<div class="container global-primary" style="margin-bottom: 40px;"><p class="global-primary dark-primary section-title rosetta-title" style="margin-left: 44px;">推薦商品<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-bottom: 2px;margin-left: 10px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div>`
                            ).insertBefore($('.container.global-primary').eq(2))
                            $(
                                '<div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div>'
                            ).insertAfter($('.rosetta-title'))
                            container = $('#rosetta-query-container')
                        }
                        let limits = 4
                        let iterator = 0
                        let haystack = []
                        // console.log('lists',lists)
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    // console.log('list.name',list.name)
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class = "global-primary dark-primary price price-crossed ">
              NT$${property.price}</div>
              <div class="price-sale price ">
              NT$${property.sale_price}
              </div></div>`
                                            : `<div class="global-primary dark-primary price">
              NT$${property.price}
              </div>`

                                    container.append(
                                        `
                <div class="product-item col-xs-6 col-md-3" data-item-type="${property.type}">
                  <a href="${property.link}" class="quick-cart-item">
                    <div class="boxify-image-wrapper">
                      <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
                      </div>
                    </div>
                    <div class="info-box">
                      <div class="info-box-inner-wrapper">
                        <div class="title text-primary-color title-container ellipsis" data-max-height="45">
                          ${property.name}
                        </div>
                        <div class="quick-cart-price">
                          ${showPrice}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindList()
                    } else if (rosetta.ab === 'on' || rosetta.ab === '') {
                        // <span style="color: #777;font-weight: lighter;text-transform: lowercase;">( powered by <span style="text-transform: none;">Rosetta.ai</span> )</span>
                        if (
                            $('.page-item-products-container')
                                .first()
                                .parent().length === 0
                        ) {
                            throw new UserError('normal index dom change')
                        }
                        $(
                            '<p class="global-primary dark-primary section-title">推薦商品<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p>'
                        ).insertBefore(
                            $('.page-item-products-container')
                                .first()
                                .parent()
                        )
                        $('.page-item-products-container')
                            .first()
                            .parent()
                            .prepend(
                                '<div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"></div>'
                            )
                        container = $('#rosetta-query-container')
                        let limits = 4
                        let iterator = 0
                        let haystack = []
                        // console.log('lists',lists)
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    // console.log('list.name',list.name)
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class = "global-primary dark-primary price price-crossed ">
              NT$${property.price}</div>
              <div class="price-sale price ">
              NT$${property.sale_price}
              </div></div>`
                                            : `<div class="global-primary dark-primary price">
              NT$${property.price}
              </div>`

                                    container.append(
                                        `
                <div class="product-item col-xs-6 col-md-3" data-item-type="${property.type}">
                  <a href="${property.link}" class="quick-cart-item">
                    <div class="boxify-image-wrapper">
                      <div class="boxify-image center-contain sl-lazy-image" style="background-image:url(${property.image_link})">
                      </div>
                    </div>
                    <div class="info-box">
                      <div class="info-box-inner-wrapper">
                        <div class="title text-primary-color title-container ellipsis" data-max-height="45">
                          ${property.name}
                        </div>
                        <div class="quick-cart-price">
                          ${showPrice}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindList()
                    }
                } else if (parsePath[1] === 'pages') {
                    let container
                    const host = window.location.host
                    // if (rosetta.ab === 'on' || rosetta.ab === '') {

                        if (host === 'www.ctshop.me') {
                            // console.log('=========')
                            // console.log(host)
                            if (parsePath[2] === 'w--chicwomen') {
                                // console.log('=========')
                                // console.log('hello')
                                $(
                                    '<div class="container global-primary"><div class="container-md-height" style="height: 100%; table-layout: fixed; width: 100%; margin-bottom: 2%;"><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%; text-align: center;"><p class="global-primary dark-primary section-title" style="margin: auto; color: #666; font-size: x-large; font-weight: bold;">你可能會喜歡&nbsp;<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div></div><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%;"><div style="height: 100%;"><div class="box-info"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div></div></div></div></div></div>'
                                ).insertAfter(
                                    $('.custom-page').children('.global-primary').eq(18)
                                )
                            }
                            if (parsePath[2] === 'kids') {
                                $(
                                    '<div class="container global-primary"><div class="container-md-height" style="height: 100%; table-layout: fixed; width: 100%; margin-bottom: 2%;"><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%; text-align: center;"><p class="global-primary dark-primary section-title" style="margin: auto; color: #666; font-size: x-large; font-weight: bold;">你可能會喜歡&nbsp;<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div></div><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%;"><div style="height: 100%;"><div class="box-info"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div></div></div></div></div></div>'
                                ).insertAfter(
                                    $('.custom-page').children('.global-primary').eq(11)
                                )
                            }

                            container = $('#rosetta-query-container').children()
                            let limits = 4
                            let iterator = 0
                            let haystack = []
                            // console.log('lists',lists)
                            lists.forEach(list => {
                                const { property, item } = list
                                if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                    // if (rosetta.ab === 'on' || rosetta.ab === '') {
                                        if (
                                            property.name.indexOf('fingerPrint') > -1 ||
                                            isNil(property.local_id) ||
                                            isNil(property.price)
                                        ) {
                                            return
                                        }
                                        let showPrice =
                                            typeof property.sale_price !== 'undefined'
                                                ? `<div class = "global-primary dark-primary price price-crossed ">
                  NT$${property.price}</div>
                  <div class="price-sale price ">
                  NT$${property.sale_price}
                  </div></div>`
                                                : `<div class="global-primary dark-primary price">
                  NT$${property.price}
                  </div>`
                                        container.append(
                                            `
                    <li class="boxify-item product-item">
                      <a href="${property.link}" class="quick-cart-item">
                        <div class="boxify-image-wrapper">
                          <div class="boxify-image center-contain sl-lazy-image " style="background-image:url(${property.image_link})"></div>
                        </div>
                        <div class="info-box" style="">
                          <div class="info-box-inner-wrapper">
                          <div class="title text-primary-color title-container ellipsis " ng-non-bindable="" style="overflow-wrap: break-word;">${property.name}</div>
                            ${showPrice}
                          </div>
                        </div>
                      </a>
                    </li>
                    `
                                        )
                                    // }
                                    haystack.push(item)
                                    iterator += 1
                                }
                            })
                            rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                            rosetta.bindNormalList()
                        } else if (host === 'www.j-well.com.tw') {
                            $(
                                '<div class="container global-primary"><div class="container-md-height" style="height: 100%; table-layout: fixed; width: 100%; margin-bottom: 2%;"><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%; text-align: center;"><p class="global-primary dark-primary section-title" style="margin: auto; color: #666; font-size: x-large; font-weight: bold;">你可能會喜歡&nbsp;<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div></div><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%;"><div style="height: 100%;"><div class="box-info"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div></div></div></div></div></div>'
                            ).insertAfter(
                                $('.CustomPage').children('.Grid-row-wrapper').eq(0)
                            )

                            container = $('#rosetta-query-container').children()
                            let limits = 4
                            let iterator = 0
                            let haystack = []
                            // console.log('lists',lists)
                            lists.forEach(list => {
                                const { property, item } = list
                                if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                    if (rosetta.ab === 'on' || rosetta.ab === '') {
                                        if (
                                            property.name.indexOf('fingerPrint') > -1 ||
                                            isNil(property.local_id) ||
                                            isNil(property.price)
                                        ) {
                                            return
                                        }
                                        let showPrice =
                                            typeof property.sale_price !== 'undefined'
                                                ? `<div class = "global-primary dark-primary price price-crossed ">
                  NT$${property.price}</div>
                  <div class="price-sale price ">
                  NT$${property.sale_price}
                  </div></div>`
                                                : `<div class="global-primary dark-primary price">
                  NT$${property.price}
                  </div>`
                                        container.append(
                                            `
                    <li class="boxify-item product-item">
                      <a href="${property.link}" class="quick-cart-item">
                        <div class="boxify-image-wrapper">
                          <div class="boxify-image center-contain sl-lazy-image " style="background-image:url(${property.image_link})"></div>
                        </div>
                        <div class="info-box" style="">
                          <div class="info-box-inner-wrapper">
                          <div class="title text-primary-color title-container ellipsis " ng-non-bindable="" style="overflow-wrap: break-word;">${property.name}</div>
                            ${showPrice}
                          </div>
                        </div>
                      </a>
                    </li>
                    `
                                        )
                                    }
                                    haystack.push(item)
                                    iterator += 1
                                }
                            })
                            rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                            rosetta.bindNormalList()
                        }
                    // }
                } else if (parsePath[1] === 'categories') {
                    let container
                    if (rosetta.ab === 'on' || rosetta.ab === '') {
                        const host = window.location.host

                        if (host === 'www.sothatsme.com.tw') {
                            $(
                                '<div class="container global-primary"><div class="container-md-height" style="height: 100%; table-layout: fixed; width: 100%; margin-bottom: 2%;"><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%;"><p class="global-primary dark-primary" style="color: #666; font-size: x-large; font-weight: bold;">你可能會喜歡&nbsp;<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div></div><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%;"><div style="height: 100%;"><div class="box-info"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div></div></div></div></div></div>'
                            ).insertBefore(
                                $('.ProductList-info')
                            )
                        }else if (host === 'www.j-well.com.tw') {
                            $(
                                '<div class="container global-primary"><div class="container-md-height" style="height: 100%; table-layout: fixed; width: 100%; margin-bottom: 2%;"><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%; text-align: center;"><p class="global-primary dark-primary section-title" style="margin: auto; color: #666; font-size: x-large; font-weight: bold;">你可能會喜歡&nbsp;<a class="quick-cart-item" style="display: inline-block;vertical-align: top;padding-top: 2px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;"></a></p></div></div><div class="row row-md-height" style="height: 100%;"><div class="item grid-products-item col-xs-12 col-md-12 col-md-height" style="vertical-align: top; height: 100%;"><div style="height: 100%;"><div class="box-info"><div class="product-items-container quick-cart-container" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div></div></div></div></div></div>'
                            ).insertAfter(
                                $('.ProductList-info')
                            )
                        } else if (host === 'shop.petmily.com') {
                            $('.product-list-container').append(
                                '<h2 class="global-primary dark-primary">你可能喜歡 <a style="display: inline-block;vertical-align: top;padding-top: 2px;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h2>'
                            )
                            $('.product-list-container').append(
                                '<div id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
                            )
                        }
                        // console.log('render類別頁')
                        else if (host === 'www.lesenphants.com.tw') {
                            $(
                                '<h2 class="global-primary dark-primary">你可能喜歡 <a style="display: inline-block;vertical-align: top;padding-top: 2px;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h2>'
                            ).insertAfter('.ProductList-info')
                            $(
                                '<div id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
                            ).insertAfter('h2.global-primary.dark-primary')
                        } else {
                            if ($('.product-list-container .page-bar') === 0) {
                                throw new UserError('normal category dom change')
                            }
                            $(
                                '<h2 class="global-primary dark-primary">你可能喜歡 <a style="display: inline-block;vertical-align: top;padding-top: 2px;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h2>'
                            ).insertAfter('.product-list-container .page-bar')
                            $(
                                '<div id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
                            ).insertAfter('h2.global-primary.dark-primary')
                        }

                        container = $('#rosetta-query-container').children()
                        let limits = 4
                        let iterator = 0
                        let haystack = []
                        // console.log('lists',lists)
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class = "global-primary dark-primary price price-crossed ">
              NT$${property.price}</div>
              <div class="price-sale price ">
              NT$${property.sale_price}
              </div></div>`
                                            : `<div class="global-primary dark-primary price">
              NT$${property.price}
              </div>`
                                    container.append(
                                        `
                <li class="boxify-item product-item">
                  <a href="${property.link}" class="quick-cart-item">
                    <div class="boxify-image-wrapper">
                      <div class="boxify-image center-contain sl-lazy-image " style="background-image:url(${property.image_link})"></div>
                    </div>
                    <div class="info-box" style="">
                      <div class="info-box-inner-wrapper">
                      <div class="title text-primary-color title-container ellipsis " ng-non-bindable="" style="overflow-wrap: break-word;">${property.name}</div>
                        ${showPrice}
                      </div>
                    </div>
                  </a>
                </li>
                `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindNormalList()
                    }
                } else if (parsePath[1] === 'products') {
                    // console.log('render商品頁')
                    let container
                    if (rosetta.ab === 'on' || rosetta.ab === '') {
                        let pgmall = window.location.href.indexOf('pgmall') > -1
                        let sothatsme = window.location.href.indexOf('sothatsme') > -1

                        if (rosetta.override && lists) {
                            // 如果是複寫相關商品，就移除相關商品 DOM
                            $('.related-products')
                                .parent()
                                .prev('h2')
                                .remove()
                            $('.related-products')
                                .parent()
                                .remove()

                            if (sothatsme) $('.ProductDetail-relatedProducts').remove()
                        }
                        if ($('.fb-comments').length === 0 && $('.product-detail-container').length === 0) {
                            throw new UserError('normal products dom change')
                        }
                        if ($('.fb-comments').length > 0) {
                            $(
                                '<h2 class="global-primary dark-primary rosetta-primary">你可能會喜歡 <a style="display: inline-block;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h2>'
                            ).insertBefore($('.fb-comments'))
                            // console.log('.global-primary.dark-primary',$('.global-primary.dark-primary'))
                            $(
                                '<div class="row" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
                            ).insertAfter($('h2.rosetta-primary'))
                        } else if ($('.product-detail-container').length > 0) {
                            $('.product-detail-container').append(
                                '<h2 class="global-primary dark-primary">你可能會喜歡 <a style="display: inline-block;margin-left: 5px;" href="https://www.rosetta.ai/?utm_source=client&amp;utm_medium=button" target="_blank"><img class="rosetta-logo" src="https://rosetta-ai.github.io/sdk.shopline/Rosetta.ai_Logo-01.png" style="width: 70px;vertical-align: top;padding-top: 2px;"></a></h2>'
                            )
                            $('.product-detail-container').append(
                                '<div class="row" id="rosetta-query-container" style="position:relative;"><ul class="related-products boxify-container"></ul></div>'
                            )
                        }
                        container = $('#rosetta-query-container').children()
                        let limits = 4
                        let iterator = 0
                        let haystack = []
                        // console.log('lists',lists)
                        lists.forEach(list => {
                            const { property, item } = list
                            if (list && $.inArray(item, haystack) < 0 && iterator < limits) {
                                if (rosetta.ab === 'on' || rosetta.ab === '') {
                                    if (
                                        property.name.indexOf('fingerPrint') > -1 ||
                                        isNil(property.local_id) ||
                                        isNil(property.price)
                                    ) {
                                        return
                                    }
                                    let showPrice =
                                        typeof property.sale_price !== 'undefined'
                                            ? `<div class = "global-primary dark-primary price price-crossed ">
          NT$${property.price}</div>
          <div class="price-sale price ">
          NT$${property.sale_price}
          </div></div>`
                                            : `<div class="global-primary dark-primary price">
          NT$${property.price}
          </div>`

                                    container.append(
                                        `
            <li class="boxify-item product-item">
              <a href="${property.link}">
                <div class="boxify-image-wrapper">
                  <div class="boxify-image center-contain sl-lazy-image " style="background-image:url(${property.image_link})"></div>
                </div>
                <div class="info-box" style="">
                  <div class="info-box-inner-wrapper">
                  <div class="title text-primary-color title-container ellipsis " ng-non-bindable="" style="overflow-wrap: break-word;">${property.name}</div>
                  ${showPrice}
                  </div>
                </div>
              </a>
            </li>
            `
                                    )
                                }
                                haystack.push(item)
                                iterator += 1
                            }
                        })
                        rosetta.sendQueryDelivered(query_id, `${limits}`, haystack)
                        rosetta.bindNormalList()
                    }
                }
            },
            setItemTimes() {},
            bindSelect() {
                // console.log('bindSelect')
                // 綁定點選購物車事件
                let cartItems = $('body')
                if (cartItems.length > 0) {
                    cartItems.on('click', function(e) {
                        let productId
                        let variation
                        // console.log($(e.target))
                        if (
                            typeof $(e.target).attr('class') !== 'undefined' &&
                            $(e.target)
                                .attr('class')
                                .indexOf('btn-add-to-cart') > -1
                        ) {
                            console.log('btn-add-to-cart')
                            const $item = $(e.target)
                            if ($item.attr('class').indexOf('sold-out-item') > -1) {
                                return
                            }

                            let href = $item.parents('a.quick-cart-item').attr('href')
                            // console.log(href)
                            let contents = !isNil(href.split('/')) ? href.split('/') : ''
                            let id = !isNil(contents[contents.length - 1]) ? contents[contents.length - 1] : ''

                            // console.log('bindSelect id', id)
                            if (id.indexOf('?variation=') > -1 || id.indexOf('?category=') > -1) {
                                let splitContents
                                if (id.indexOf('?variation=') > -1) {
                                    splitContents = id.split('?variation=')
                                    variation = splitContents[1]
                                } else if (id.indexOf('?category=') > -1) {
                                    splitContents = id.split('?category=')
                                    variation = splitContents[1]
                                }
                                productId = splitContents[0]

                            rosetta.sendEvent(productId, 'select', null, false)
                            } else if (
                                ($item.parents('a.quick-cart-item').attr('ng-click') && $item
                                .parents('a.quick-cart-item')
                                .attr('ng-click')
                                .indexOf('key') > -1) ||
                                    ($item.parents('a.Product-item').attr('ng-click') &&
                                    $item
                                        .parents('a.Product-item')
                                        .attr('ng-click')
                                        .indexOf('key') > -1)
                            ) {
                                let clickDate
                                if (!isNil($item.parents('a.quick-cart-item').attr('ng-click'))) {
                                    clickDate = $item
                                        .parents('a.quick-cart-item')
                                        .attr('ng-click')
                                        .replace(/&quot;/g, '"')
                                        .replace(/\\"/g, '"')
                                } else if (!isNil($item.parents('a.Product-item').attr('ng-click'))) {
                                    clickDate = $item
                                        .parents('a.Product-item')
                                        .attr('ng-click')
                                        .replace(/&quot;/g, '"')
                                        .replace(/\\"/g, '"')
                                }
                                // console.log('clickDate',clickDate);
                                productId = id
                                variation = !isNil(clickDate) ? clickDate.substr(clickDate.indexOf('key') + 6, 24) : null
                                console.log('variation',variation)
                                let combineId = !isNil(variation) ? `${productId}:${variation}` :productId
                                rosetta.sendEvent(combineId, 'select', null, false)
                                // console.log('2', $item.parents('a.quick-cart-item').attr('ng-click'))
                            } else {
                                productId = id

                            rosetta.sendEvent(productId, 'select', null, false)
                            }
                        } else if ($('#btn-add-to-cart').length > 0) {
                            // console.log('bind select 2')
                            let local_id
                            let queryId
                            let source = null
                            let worthyAb = true
                            let itemWorthyAb = false
                             let recentItemSource = null
                            if (rosetta.ab === '') {
                                worthyAb = false
                            }
                            let clickRosetta = []
                            // console.log($(e.target), $(e.target).attr('id') === 'btn-add-to-cart')
                            if (
                                typeof $(e.target).attr('id') !== 'undefined' &&
                                ($(e.target).attr('id') === 'btn-add-to-cart' ||
                                    $(e.target).attr('id') === 'btn-main-checkout')
                            ) {
                                const $item = $(e.target)
                                dataLayer.forEach(arg => {
                                    let args = Array.prototype.slice.call(arg)
                                    args.forEach(arr => {
                                        if (arr.ecomm_prodid) {
                                            queryId = arr.ecomm_prodid
                                        }
                                    })
                                })

                                if (!isNil(queryId) && queryId.length < 24) {
                                    ;[...document.getElementsByTagName('script')].forEach(item => {
                                        if (item.innerText.indexOf('Product ID') !== -1) {
                                            queryId = item.innerText.substr(
                                                item.innerText.indexOf('Product ID') + 13,
                                                24
                                            )
                                            // console.log('當queryId小於正常值,從新抓取Product ID值','currQueryId:',currQueryId)
                                        }
                                    })
                                }

                                try {
                                    // console.log('start to select')
                                    let groupEvent = JSON.parse(localStorage.getItem('groupEvent')) || null
                                    local_id = JSON.parse(localStorage.getItem('queue')) || null
                                    if (
                                        isNil(queryId) &&
                                        (location.hostname === 'www.drqq.toys' ||
                                            location.hostname === 'www.yohopower.tw')
                                    ) {
                                        queryId = local_id
                                    }
                                    if (!isNil(groupEvent)) {
                                        clickRosetta = groupEvent.reverse().filter((item, index) => {
                                            // console.log('item', item)
                                            for (let property in item) {
                                                // console.log('item[property]', item[property])
                                                return item[property][1] === local_id && item[property][0] === 'click'
                                            }
                                        })
                                    }
                                    // console.log('clickRosetta', clickRosetta)
                                    recentItemSource = Object.values(clickRosetta[0])[0][2]
                                    itemWorthyAb = Object.values(clickRosetta[0])[0][3]
                                    // console.log('recentItemSource', recentItemSource)
                                    // console.log('select', 'local_id:', local_id, 'queryId:', queryId)
                                    if (location.hostname === 'www.sole143.me') {
                                        // console.log('sole143.me start')
                                        let diffLocalId = local_id
                                        let diffQueryId = queryId
                                        // console.log('diffLocalId', diffLocalId, 'diffQueryId', diffQueryId)
                                        if (diffLocalId.indexOf(':') > -1) {
                                            diffLocalId = diffLocalId.split(':')[0]
                                        }
                                        if (diffQueryId.indexOf(':') > -1) {
                                            diffQueryId = diffQueryId.split(':')[0]
                                        }
                                        if (
                                            !isNil(diffLocalId) &&
                                            !isNil(diffQueryId) &&
                                            diffLocalId.indexOf(diffQueryId) > -1
                                        ) {
                                            // console.log('send 1')
                                            if (!isNil(recentItemSource)) {
                                                if (!isNil(localStorage.getItem('groupEvent'))) {
                                                    const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                                    // console.log('preData', preData)
                                                    const newData = [
                                                        ...preData,
                                                        { [timestamp]: ['select', local_id, recentItemSource, itemWorthyAb] },
                                                    ]
                                                    // console.log('newData', newData)
                                                    localStorage.setItem('groupEvent', JSON.stringify(newData))
                                                } else {
                                                    localStorage.setItem(
                                                        'groupEvent',
                                                        JSON.stringify([
                                                            {
                                                                [timestamp]: [
                                                                    'select',
                                                                    local_id,
                                                                    recentItemSource,
                                                                    itemWorthyAb,
                                                                ],
                                                            },
                                                        ])
                                                    )
                                                }
                                            } else {
                                                if (!isNil(localStorage.getItem('groupEvent'))) {
                                                    const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                                    const newData = [
                                                        ...preData,
                                                        { [timestamp]: ['select', local_id, null, itemWorthyAb] },
                                                    ]
                                                    localStorage.setItem('groupEvent', JSON.stringify(newData))
                                                } else {
                                                    localStorage.setItem(
                                                        'groupEvent',
                                                        JSON.stringify([
                                                            { [timestamp]: ['select', local_id, null, itemWorthyAb] },
                                                        ])
                                                    )
                                                }
                                            }
                                        }

                                        setTimeout(function() {
                                            let worthyAb = true
                                            if (rosetta.ab === '') {
                                                worthyAb = false
                                            }
                                            if ($('button.btn-quick-cart-add-to-cart').length > 0) {
                                                $('button.btn-quick-cart-add-to-cart').on('click', function() {
                                                    if (typeof productId !== 'undefined') {
                                                        if (!isNil(variation)) {
                                                            rosetta.sendEvent(`${productId}:${variation}`, 'select', recentItemSource, itemWorthyAb)

                                                        } else {
                                                            rosetta.sendEvent(productId, 'select', recentItemSource, itemWorthyAb)

                                                        }
                                                    }
                                                })
                                            }else if($('.btn-custom').length > 0 && $('.btn-custom').closest('.os-content').find('a.ng-binding').length > 0){
                                                $('btn-custom').on('click',function(){
                                                    let items = $('.btn-custom').closest('.os-content').find('a.ng-binding')
                                                    let itemId
                                                    items.get().forEach(item=>{
                                                        if($(item).text().indexOf('商品資訊') > -1){
                                                          let itemUrl = $(item).attr('href')
                                                        //   console.log(itemUrl)
                                                          itemId = itemUrl.split('/')[2]
                                                        //   console.log(id)
                                                        }
                                                      })
                                                      if(!isNil(itemId)){
                                                      rosetta.sendEvent(itemId, 'select', recentItemSource, itemWorthyAb)

                                                    }
                                                })
                                            }
                                            else {
                                                    rosetta.sendEvent(queryId, 'select', recentItemSource, itemWorthyAb)

                                            }
                                        }, 1000)
                                        // console.log('diffLocalId:', diffLocalId, 'diffQueryId:', diffQueryId)
                                    } else {
                                        if (!isNil(local_id) && !isNil(queryId) && local_id.indexOf(queryId) > -1) {
                                            // console.log('send 1')
                                            // console.log(
                                            //     'local_id',
                                            //     local_id,
                                            //     'queryId',
                                            //     queryId,
                                            //     'recentItemSource',
                                            //     recentItemSource
                                            // )
                                            if (!isNil(recentItemSource)) {
                                                if (!isNil(localStorage.getItem('groupEvent'))) {
                                                    const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                                    const newData = [
                                                        ...preData,
                                                        { [timestamp]: ['select', local_id, recentItemSource, itemWorthyAb] },
                                                    ]
                                                    // console.log('preData', preData, 'newData', newData)
                                                    localStorage.setItem('groupEvent', JSON.stringify(newData))
                                                } else {
                                                    localStorage.setItem(
                                                        'groupEvent',
                                                        JSON.stringify([
                                                            {
                                                                [timestamp]: [
                                                                    'select',
                                                                    local_id,
                                                                    recentItemSource,
                                                                    itemWorthyAb,
                                                                ],
                                                            },
                                                        ])
                                                    )
                                                }
                                                console.log('local_id,query_id,1')
                                            } else {
                                                if (!isNil(localStorage.getItem('groupEvent'))) {
                                                    const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                                    const newData = [
                                                        ...preData,
                                                        { [timestamp]: ['select', local_id, null, itemWorthyAb] },
                                                    ]
                                                    localStorage.setItem('groupEvent', JSON.stringify(newData))
                                                } else {
                                                    localStorage.setItem(
                                                        'groupEvent',
                                                        JSON.stringify([
                                                            { [timestamp]: ['select', local_id, null, itemWorthyAb] },
                                                        ])
                                                    )
                                                }
                                                console.log('local_id,query_id,2')
                                            }
                                        } else if (
                                            !isNil(local_id) &&
                                            !isNil(queryId) &&
                                            queryId.indexOf(local_id) > -1
                                        ) {
                                            // console.log('send 2')
                                            if (!isNil(recentItemSource)) {
                                                if (!isNil(localStorage.getItem('groupEvent'))) {
                                                    const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                                    const newData = [
                                                        ...preData,
                                                        { [timestamp]: ['select', local_id, recentItemSource, itemWorthyAb] },
                                                    ]
                                                    localStorage.setItem('groupEvent', JSON.stringify(newData))
                                                } else {
                                                    localStorage.setItem(
                                                        'groupEvent',
                                                        JSON.stringify([
                                                            {
                                                                [timestamp]: [
                                                                    'select',
                                                                    local_id,
                                                                    recentItemSource,
                                                                    itemWorthyAb,
                                                                ],
                                                            },
                                                        ])
                                                    )
                                                }
                                                console.log('local_id,query_id,3')
                                            } else {
                                                if (!isNil(localStorage.getItem('groupEvent'))) {
                                                    const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                                    const newData = [
                                                        ...preData,
                                                        { [timestamp]: ['select', local_id, null, itemWorthyAb] },
                                                    ]
                                                    localStorage.setItem('groupEvent', JSON.stringify(newData))
                                                } else {
                                                    localStorage.setItem(
                                                        'groupEvent',
                                                        JSON.stringify([
                                                            { [timestamp]: ['select', local_id, null, itemWorthyAb] },
                                                        ])
                                                    )
                                                }
                                                console.log('local_id,query_id,4')
                                            }
                                        }
                                        setTimeout(function() {
                                            let worthyAb = true
                                            if (rosetta.ab === '') {
                                                worthyAb = false
                                            }
                                            if ($('button.btn-quick-cart-add-to-cart').length > 0) {
                                                $('button.btn-quick-cart-add-to-cart').on('click', function() {
                                                    if (typeof productId !== 'undefined') {
                                                        if (!isNil(variation)) {
                                                            rosetta.sendEvent(`${productId}:${variation}`, 'select', null, itemWorthyAb)

                                                        } else {
                                                            rosetta.sendEvent(productId, 'select', null, itemWorthyAb)

                                                        }
                                                    }
                                                })
                                            }else if($('.btn-custom').length > 0 && $('.btn-custom').closest('.os-content').find('a.ng-binding').length > 0){
                                                $('btn-custom').on('click',function(){
                                                    let items = $('.btn-custom').closest('.os-content').find('a.ng-binding')
                                                    let itemId
                                                    items.get().forEach(item=>{
                                                        if($(item).text().indexOf('商品資訊') > -1){
                                                          let itemUrl = $(item).attr('href')
                                                        //   console.log(itemUrl)
                                                          itemId = itemUrl.split('/')[2]
                                                        //   console.log(id)
                                                        }
                                                      })
                                                      if(!isNil(itemId)){
                                                      rosetta.sendEvent(itemId, 'select', null, itemWorthyAb)

                                                    }
                                                })
                                            }
                                            else {
                                                    rosetta.sendEvent(queryId, 'select', recentItemSource, itemWorthyAb)

                                            }
                                        }, 1000)
                                    }


                                } catch (error) {
                                    // error
                                }
                            }
                        }


                    })
                }
            },
            setLocalStorage() {
                // console.log('setItem')
                var counter = 0
                function addItem(event, name, value) {
                    if (event === 'click' && counter > 0) {
                        // console.log('re set')
                        setTimeout(() => {
                            counter = 0
                        }, 1000)
                        return
                    }
                    counter += 1
                    localStorage.setItem(name, value)
                    // console.log('counter in', counter)
                    return counter
                }
                return addItem
            },
            bindList() {
                const area = $('a.quick-cart-item') || $('a.Product-item')
                rosetta.bindItem(area)
            },
            bindItem(area) {
                $(area).on('click', function(e) {
                    if(typeof $(e.target).attr('class') !== 'indefined' && $(e.target).attr('class').indexOf('btn-add-to-cart') > -1){
                       return
                    }
                    let $item = $(e.target).parents('a')
                    rosetta.setItem($item, false)
                })
            },
            setItem(item, worthyAb) {
                console.log('item, worthyAb', item, worthyAb)
                let $item = $(item)
                // console.log('$item', $item)
                let href = $item.attr('href')
                let contents = href.split('/')
                let id = contents[contents.length - 1]
                // console.log('href contents id', href, contents, id)

                if (id && (id.indexOf('?variation=') > -1 || id.indexOf('?category=')) > -1) {
                    // console.log('click no ng-click bindList', id, worthyAb)
                    if (id.indexOf('?variation=') > -1) {
                        id = id.replace('?variation=', ':')
                        // console.log('replace variation')
                    } else if (id.indexOf('?category=') > -1) {
                        id = id.replace('?category=', ':')
                        // console.log('replace category')
                    }
                    // console.log("id.indexOf('')", id)
                    try {
                        // console.log('removeItem queue')
                        // console.log('ab1')
                        if (worthyAb && rosetta.ab === 'on') {
                            if (!isNil(localStorage.getItem('groupEvent'))) {
                                const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                const newData = JSON.stringify([
                                    ...preData,
                                    { [timestamp]: ['click', id, rosetta.source, worthyAb] },
                                ])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            } else {
                                const newData = JSON.stringify([
                                    { [timestamp]: ['click', id, rosetta.source, worthyAb] },
                                ])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            }
                            // console.log('setItem queue worthyAb')
                        } else if (worthyAb && rosetta.ab === 'off') {
                            if (!isNil(localStorage.getItem('groupEvent'))) {
                                const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                const newData = JSON.stringify([
                                    ...preData,
                                    { [timestamp]: ['click', id, null, worthyAb] },
                                ])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            } else {
                                const newData = JSON.stringify([{ [timestamp]: ['click', id, null, worthyAb] }])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            }
                            // console.log(localStorage.getItem('queue')) // 如果商品有多樣規格，到商品頁才能知道詳細 id（這編取到的是 group_id）
                        } else {
                            if (!isNil(localStorage.getItem('groupEvent'))) {
                                const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                // const newData = [...preData, { [timestamp]: ['click', id, null, worthyAb] }]
                                const newData = JSON.stringify([
                                    ...preData,
                                    { [timestamp]: ['click', id, null, false] },
                                ])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            } else {
                                const newData = JSON.stringify([{ [timestamp]: ['click', id, null, false] }])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            }
                        }
                        localStorage.setItem('queue', JSON.stringify(id))
                    } catch (error) {
                        // 不支援 localStorage
                    }
                    // console.log('mix_local_id',mix_local_id)
                } else if (
                    id.indexOf('?variation=') === -1 &&
                    id.indexOf('?category=') === -1 &&
                    $item.closest('div') &&
                    $item.closest('div').attr('ga-product')
                ) {
                    // console.log('item have ga-product', id, worthyAb)
                    let clickDate = $item.closest('div').attr('ga-product')
                    let idObj = JSON.parse(clickDate)
                    let newId = idObj.id
                    let variationIdObj = idObj.variations.replace(/&quot;/g, '"')
                    let variationId = ''
                    // console.log('clickDate', clickDate, idObj, newId, variationIdObj, variationId)
                    if (!isNil(JSON.parse(variationIdObj)[0])) {
                        variationId = JSON.parse(variationIdObj)[0].key
                        newId = `${newId}:${variationId}`
                    }
                    // console.log('item ga-product', id, 'variationId', variationId)
                    // console.log('click ng-click bindList',`${id}:${variationId}`)
                    try {
                        // console.log('ng-click', 'worthyAb', worthyAb, 'rosetta.ab', rosetta.ab)
                        if (worthyAb && rosetta.ab === 'on') {
                            if (!isNil(localStorage.getItem('groupEvent'))) {
                                const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                const newData = JSON.stringify([
                                    ...preData,
                                    { [timestamp]: ['click', newId, rosetta.source, worthyAb] },
                                ])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            } else {
                                const newData = JSON.stringify([
                                    { [timestamp]: ['click', newId, rosetta.source, worthyAb] },
                                ])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            }
                        } else if (worthyAb && rosetta.ab === 'off') {
                            if (!isNil(localStorage.getItem('groupEvent'))) {
                                const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                const newData = JSON.stringify([
                                    ...preData,
                                    { [timestamp]: ['click', newId, null, worthyAb] },
                                ])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            } else {
                                const newData = JSON.stringify([{ [timestamp]: ['click', newId, null, worthyAb] }])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            }
                        } else {
                            // console.log('other group')
                            if (!isNil(localStorage.getItem('groupEvent'))) {
                                // console.log('other group if')
                                const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                const newData = JSON.stringify([
                                    ...preData,
                                    { [timestamp]: ['click', newId, null, worthyAb] },
                                ])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            } else {
                                // console.log('other group else')
                                const newData = JSON.stringify([{ [timestamp]: ['click', newId, null, false] }])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            }
                        }
                        // console.log('set queue', newId)
                        localStorage.setItem('queue', JSON.stringify(newId))
                        // console.log(localStorage.getItem('queue')) // 如果商品有多樣規格，到商品頁才能知道詳細 id（這編取到的是 group_id）
                    } catch (error) {
                        // 不支援 localStorage
                    }
                } else if (
                    id.indexOf('?variation=') === -1 &&
                    id.indexOf('?category=') === -1 &&
                    $item.attr('ng-click') &&
                    $item.attr('ng-click').indexOf('key') !== -1
                ) {
                    // console.log('item have ng-click', id, worthyAb)
                    let clickDate = $item
                        .attr('ng-click')
                        .replace(/&quot;/g, '"')
                        .replace(/\\"/g, '"')
                    // console.log('clickDate', clickDate)
                    let variationId = clickDate.substr(clickDate.indexOf('key') + 6, 24)
                    // console.log('item ng-click', id, 'variationId', variationId)
                    // console.log('click ng-click bindList',`${id}:${variationId}`)
                    try {
                        // console.log('click bindListmix',`${id}:${variationId}`)
                        // localStorage.removeItem('queue')
                        if (worthyAb && rosetta.ab === 'on') {
                            if (!isNil(localStorage.getItem('groupEvent'))) {
                                const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                const newData = JSON.stringify([
                                    ...preData,
                                    { [timestamp]: ['click', `${id}:${variationId}`, rosetta.source, worthyAb] },
                                ])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            } else {
                                const newData = JSON.stringify([
                                    { [timestamp]: ['click', `${id}:${variationId}`, rosetta.source, worthyAb] },
                                ])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            }
                        } else if (worthyAb && rosetta.ab === 'off') {
                            if (!isNil(localStorage.getItem('groupEvent'))) {
                                const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                const newData = JSON.stringify([
                                    ...preData,
                                    { [timestamp]: ['click', `${id}:${variationId}`, null, worthyAb] },
                                ])
                                // localStorage.setItem('groupEvent', JSON.stringify(newData))
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            } else {
                                const newData = JSON.stringify([
                                    { [timestamp]: ['click', `${id}:${variationId}`, null, worthyAb] },
                                ])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            }
                        } else {
                            if (!isNil(localStorage.getItem('groupEvent'))) {
                                const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                const newData = JSON.stringify([
                                    ...preData,
                                    { [timestamp]: ['click', `${id}:${variationId}`, null, worthyAb] },
                                ])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            } else {
                                const newData = JSON.stringify([
                                    { [timestamp]: ['click', `${id}:${variationId}`, null, false] },
                                ])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            }
                        }
                        localStorage.setItem('queue', JSON.stringify(`${id}:${variationId}`))
                        // console.log(localStorage.getItem('queue')) // 如果商品有多樣規格，到商品頁才能知道詳細 id（這編取到的是 group_id）
                    } catch (error) {
                        // 不支援 localStorage
                    }
                } else {
                    // console.log('click bind normal-click List', id, worthyAb)

                    try {
                        // localStorage.removeItem('queue')
                        if (worthyAb && rosetta.ab === 'on') {
                            if (!isNil(localStorage.getItem('groupEvent'))) {
                                const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                const newData = JSON.stringify([
                                    ...preData,
                                    { [timestamp]: ['click', id, rosetta.source, worthyAb] },
                                ])
                                // localStorage.setItem('groupEvent', JSON.stringify(newData))
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            } else {
                                localStorage.setItem(
                                    'groupEvent',
                                    JSON.stringify([{ [timestamp]: ['click', id, rosetta.source, worthyAb] }])
                                )
                                const newData = JSON.stringify([
                                    { [timestamp]: ['click', id, rosetta.source, worthyAb] },
                                ])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            }
                        } else if (worthyAb && rosetta.ab === 'off') {
                            if (!isNil(localStorage.getItem('groupEvent'))) {
                                const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                const newData = JSON.stringify([
                                    ...preData,
                                    { [timestamp]: ['click', id, null, worthyAb] },
                                ])
                                // localStorage.setItem('groupEvent', JSON.stringify(newData))
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            } else {
                                localStorage.setItem(
                                    'groupEvent',
                                    JSON.stringify([{ [timestamp]: ['click', id, null, worthyAb] }])
                                )
                                const newData = JSON.stringify([{ [timestamp]: ['click', id, null, worthyAb] }])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            }
                        } else {
                            if (!isNil(localStorage.getItem('groupEvent'))) {
                                const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                const newData = JSON.stringify([
                                    ...preData,
                                    { [timestamp]: ['click', id, null, worthyAb] },
                                ])
                                // localStorage.setItem('groupEvent', JSON.stringify(newData))
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            } else {
                                localStorage.setItem(
                                    'groupEvent',
                                    JSON.stringify([{ [timestamp]: ['click', id, null, false] }])
                                )
                                const newData = JSON.stringify([{ [timestamp]: ['click', id, null, false] }])
                                rosetta.setLocalStorage()('click', 'groupEvent', newData)
                            }
                        }
                        localStorage.setItem('queue', JSON.stringify(id))
                        // console.log(localStorage.getItem('queue')) // 如果商品有多樣規格，到商品頁才能知道詳細 id（這編取到的是 group_id）
                    } catch (error) {
                        // 不支援 localStorage
                    }
                }
            },
            getCategoryType() {
                const len = $('.ProductList-breadcrumb  a').length > 0
                const elseLen = $('.breadcrumb h1').length > 0
                if (len) {
                    let cateItem = $('.ProductList-breadcrumb  a')[len - 1]
                    const regex = /(【|】)/gi
                    let filterSign = $(cateItem)
                        .text()
                        .replace(regex, '')
                    let cateQueryItem = filterSign.split('｜').filter((item, idx) => {
                        return idx === 0
                    })
                    return JSON.stringify(cateQueryItem)
                } else if (elseLen) {
                    let cateQueryItem = []
                    cateQueryItem.push($('.breadcrumb h1').text())
                    return JSON.stringify(cateQueryItem)
                }
            },
            bindNormalList() {
                // console.log('start to bind')
                let path = rosetta.getPath()
                let parsePath = path.split('/')
                let area
                if (parsePath[1] === 'categories') {
                    // console.log('bind categories')
                    area = $('#Content>div').length > 0 ? $('#Content>div') : $('.yield-wrapper>div')
                    rosetta.bindCatItem(area)
                } else if ($('.boxify-container').length > 0) {
                    // console.log('bind 商品頁')
                    area = $('.boxify-container')
                    rosetta.bindNormalItem(area)
                } else if ($('.ProductDetail-relatedProducts-list').length > 0) {
                    // console.log('bind 商品頁')
                    area = $('.ProductDetail-relatedProducts-list')
                    rosetta.bindNormalItem(area)
                }
            },
            bindNormalItem(area) {
                // console.log('bindNormalItem')
                let items = $(area).find('a')
                let worthyAb = true
                if (rosetta.ab === '') {
                    worthyAb = false
                }
                let override = rosetta.override
                let path = rosetta.getPath()
                let parsePath = path.split('/')
                if (parsePath[1] === 'categories') {
                    worthyAb = false
                }
                if (items.length > 0) {
                    const limits = items.length

                    if (rosetta.ab === 'off') {
                        rosetta.sendQueryDelivered(null, `${limits}`, null)
                    }
                }

                items.get().forEach(item => {
                    let $item = $(item)
                    // console.log($item, '$item')
                    let href = $item.attr('href')
                    let contents = href.split('/')
                    let id = contents[contents.length - 1]
                    // $item.attr('target', '_blank')
                    // console.log('1', id)
                    if (id && (id.indexOf('?variation=') > -1 || id.indexOf('?category=')) > -1) {
                        if (id.indexOf('?variation=') > -1) {
                            id = id.replace('?variation=', ':')
                        } else if (id.indexOf('?category=') > -1) {
                            id = id.replace('?category=', ':')
                        }
                        //  console.log("id.indexOf('?variation=')",id)

                        $item.on('click', function(e) {
                            // console.log('aa', $(e.target).parents('div#rosetta-query-container'))
                            // let source = $(event.target).closest('ProductDetail-relatedProducts-list').attr("id") === 'rosetta-query-container' ? rosetta.source : null
                            let source =
                                !isNil($(e.target).parents('div#rosetta-query-container')) &&
                                $(e.target)
                                    .parents('div#rosetta-query-container')
                                    .attr('id') === 'rosetta-query-container' && rosetta.ab !== ''
                                    ? rosetta.source
                                    : null
                            // console.log('source', source)
                            // console.log('click no ng-click bindList', id)
                            try {
                                // console.log('click bindList', id)
                                // localStorage.removeItem('queue')
                                if (override) {
                                    // console.log('override ab1')
                                    if (!isNil(source)) {
                                        if (!isNil(localStorage.getItem('groupEvent'))) {
                                            const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                            const newData = [
                                                ...preData,
                                                { [timestamp]: ['click', id, source, worthyAb] },
                                            ]
                                            localStorage.setItem('groupEvent', JSON.stringify(newData))
                                        } else {
                                            localStorage.setItem(
                                                'groupEvent',
                                                JSON.stringify([{ [timestamp]: ['click', id, source, worthyAb] }])
                                            )
                                        }
                                    } else {
                                        if (!isNil(localStorage.getItem('groupEvent'))) {
                                            const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                            const newData = [
                                                ...preData,
                                                { [timestamp]: ['click', id, source, worthyAb] },
                                            ]
                                            localStorage.setItem('groupEvent', JSON.stringify(newData))
                                        } else {
                                            localStorage.setItem(
                                                'groupEvent',
                                                JSON.stringify([{ [timestamp]: ['click', id, source, worthyAb] }])
                                            )
                                        }
                                    }
                                } else {
                                    if (!isNil(source)) {
                                        if (!isNil(localStorage.getItem('groupEvent'))) {
                                            const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                            const newData = [
                                                ...preData,
                                                { [timestamp]: ['click', id, source, worthyAb] },
                                            ]
                                            localStorage.setItem('groupEvent', JSON.stringify(newData))
                                        } else {
                                            localStorage.setItem(
                                                'groupEvent',
                                                JSON.stringify([{ [timestamp]: ['click', id, source, worthyAb] }])
                                            )
                                        }
                                    } else {
                                        if (!isNil(localStorage.getItem('groupEvent'))) {
                                            const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                            const newData = [
                                                ...preData,
                                                { [timestamp]: ['click', id, source, worthyAb] },
                                            ]
                                            localStorage.setItem('groupEvent', JSON.stringify(newData))
                                        } else {
                                            localStorage.setItem(
                                                'groupEvent',
                                                JSON.stringify([{ [timestamp]: ['click', id, source, worthyAb] }])
                                            )
                                        }
                                    }
                                }
                                localStorage.setItem('queue', JSON.stringify(id))
                                // console.log(localStorage.getItem('queue')) // 如果商品有多樣規格，到商品頁才能知道詳細 id（這編取到的是 group_id）
                            } catch (error) {
                                // 不支援 localStorage
                            }
                        })
                        // console.log('mix_local_id',mix_local_id)
                    } else if (
                        id.indexOf('?variation=') === -1 &&
                        id.indexOf('?category=') === -1 &&
                        !isNil(item.getAttribute('ng-click')) &&
                        item.getAttribute('ng-click').indexOf('key') !== -1
                    ) {
                        // console.log('item have ng-click')
                        let clickDate = item
                            .getAttribute('ng-click')
                            .replace(/&quot;/g, '"')
                            .replace(/\\"/g, '"')
                        // console.log('clickDate',clickDate);
                        let variationId = clickDate.substr(clickDate.indexOf('key') + 6, 24)
                        // console.log('item ng-click',id,'variationId',variationId);
                        $item.on('click', function(e) {
                            // console.log('aa', $(e.target).parents('div#rosetta-query-container'))
                            // let source = $(event.target).closest('ProductDetail-relatedProducts-list').attr("id") === '' ? rosetta.source : null
                            let source =
                                !isNil($(e.target).parents('div#rosetta-query-container')) &&
                                $(e.target)
                                    .parents('div#rosetta-query-container')
                                    .attr('id') === 'rosetta-query-container'
                                    ? rosetta.source
                                    : null
                            // console.log('source', source)
                            // console.log('click ng-click bindList', `${id}:${variationId}`)
                            try {
                                // localStorage.removeItem('queue')
                                if (override) {
                                    // console.log('override ab2')
                                    if (!isNil(source)) {
                                        if (!isNil(localStorage.getItem('groupEvent'))) {
                                            const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                            const newData = [
                                                ...preData,
                                                { [timestamp]: ['click', `${id}:${variationId}`, source, worthyAb] },
                                            ]
                                            localStorage.setItem('groupEvent', JSON.stringify(newData))
                                        } else {
                                            localStorage.setItem(
                                                'groupEvent',
                                                JSON.stringify([
                                                    {
                                                        [timestamp]: [
                                                            'click',
                                                            `${id}:${variationId}`,
                                                            source,
                                                            worthyAb,
                                                        ],
                                                    },
                                                ])
                                            )
                                        }
                                    } else {
                                        if (!isNil(localStorage.getItem('groupEvent'))) {
                                            const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                            const newData = [
                                                ...preData,
                                                { [timestamp]: ['click', `${id}:${variationId}`, source, worthyAb] },
                                            ]
                                            localStorage.setItem('groupEvent', JSON.stringify(newData))
                                        } else {
                                            localStorage.setItem(
                                                'groupEvent',
                                                JSON.stringify([
                                                    {
                                                        [timestamp]: [
                                                            'click',
                                                            `${id}:${variationId}`,
                                                            source,
                                                            worthyAb,
                                                        ],
                                                    },
                                                ])
                                            )
                                        }
                                    }
                                } else {
                                    if (!isNil(source)) {
                                        if (!isNil(localStorage.getItem('groupEvent'))) {
                                            const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                            const newData = [
                                                ...preData,
                                                { [timestamp]: ['click', `${id}:${variationId}`, source, worthyAb] },
                                            ]
                                            localStorage.setItem('groupEvent', JSON.stringify(newData))
                                        } else {
                                            localStorage.setItem(
                                                'groupEvent',
                                                JSON.stringify([
                                                    {
                                                        [timestamp]: [
                                                            'click',
                                                            `${id}:${variationId}`,
                                                            source,
                                                            worthyAb,
                                                        ],
                                                    },
                                                ])
                                            )
                                        }
                                    } else {
                                        if (!isNil(localStorage.getItem('groupEvent'))) {
                                            const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                            const newData = [
                                                ...preData,
                                                { [timestamp]: ['click', `${id}:${variationId}`, source, worthyAb] },
                                            ]
                                            localStorage.setItem('groupEvent', JSON.stringify(newData))
                                        } else {
                                            localStorage.setItem(
                                                'groupEvent',
                                                JSON.stringify([
                                                    {
                                                        [timestamp]: [
                                                            'click',
                                                            `${id}:${variationId}`,
                                                            source,
                                                            worthyAb,
                                                        ],
                                                    },
                                                ])
                                            )
                                        }
                                    }
                                }
                                // console.log('click bindListmix',`${id}:${variationId}`)
                                localStorage.setItem('queue', JSON.stringify(`${id}:${variationId}`))
                                // console.log(localStorage.getItem('queue')) // 如果商品有多樣規格，到商品頁才能知道詳細 id（這編取到的是 group_id）
                            } catch (error) {
                                // 不支援 localStorage
                            }
                        })
                    } else {
                        $item.on('click', function(e) {
                            // console.log('aa', $(e.target).parents('div#rosetta-query-container'))
                            // let source = $(event.target).closest('ProductDetail-relatedProducts-list').attr("id") === '' ? rosetta.source : null
                            let source =
                                !isNil($(e.target).parents('div#rosetta-query-container')) &&
                                $(e.target)
                                    .parents('div#rosetta-query-container')
                                    .attr('id') === 'rosetta-query-container'
                                    ? rosetta.source
                                    : null
                            // console.log('source', source)
                            // console.log('click bind normal-click List', id)
                            try {
                                // localStorage.removeItem('queue')
                                if (override) {
                                    // console.log('override ab3')
                                    if (!isNil(source)) {
                                        if (!isNil(localStorage.getItem('groupEvent'))) {
                                            const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                            const newData = [
                                                ...preData,
                                                { [timestamp]: ['click', id, source, worthyAb] },
                                            ]
                                            localStorage.setItem('groupEvent', JSON.stringify(newData))
                                        } else {
                                            localStorage.setItem(
                                                'groupEvent',
                                                JSON.stringify([{ [timestamp]: ['click', id, source, worthyAb] }])
                                            )
                                        }
                                    } else {
                                        if (!isNil(localStorage.getItem('groupEvent'))) {
                                            const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                            const newData = [
                                                ...preData,
                                                { [timestamp]: ['click', id, source, worthyAb] },
                                            ]
                                            localStorage.setItem('groupEvent', JSON.stringify(newData))
                                        } else {
                                            localStorage.setItem(
                                                'groupEvent',
                                                JSON.stringify([{ [timestamp]: ['click', id, source, worthyAb] }])
                                            )
                                        }
                                    }
                                } else {
                                    if (!isNil(source)) {
                                        if (!isNil(localStorage.getItem('groupEvent'))) {
                                            const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                            const newData = [
                                                ...preData,
                                                { [timestamp]: ['click', id, source, worthyAb] },
                                            ]
                                            localStorage.setItem('groupEvent', JSON.stringify(newData))
                                        } else {
                                            localStorage.setItem(
                                                'groupEvent',
                                                JSON.stringify([{ [timestamp]: ['click', id, source, worthyAb] }])
                                            )
                                        }
                                    } else {
                                        if (!isNil(localStorage.getItem('groupEvent'))) {
                                            const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                            const newData = [
                                                ...preData,
                                                { [timestamp]: ['click', id, source, worthyAb] },
                                            ]
                                            localStorage.setItem('groupEvent', JSON.stringify(newData))
                                        } else {
                                            localStorage.setItem(
                                                'groupEvent',
                                                JSON.stringify([{ [timestamp]: ['click', id, source, worthyAb] }])
                                            )
                                        }
                                    }
                                }
                                localStorage.setItem('queue', JSON.stringify(id))
                                // console.log(localStorage.getItem('queue')) // 如果商品有多樣規格，到商品頁才能知道詳細 id（這編取到的是 group_id）
                            } catch (error) {
                                // 不支援 localStorage
                            }
                        })
                    }
                })
            },
            bindCatItem(area) {
                // console.log('bindNormalItem')
                let items = $(area).find('a')
                items.get().forEach(item => {
                    let $item = $(item)
                    // console.log($item, '$item')
                    let href = $item.attr('href')
                    let contents = href.split('/')
                    let id = contents[contents.length - 1]
                    const isLocalID = /^[a-z0-9]+$/
                    // console.log('1', id)
                    let override = rosetta.override
                    if (id && (id.indexOf('?variation=') > -1 || id.indexOf('?category=')) > -1) {
                        if (id.indexOf('?variation=') > -1) {
                            id = id.replace('?variation=', ':')
                        } else if (id.indexOf('?category=') > -1) {
                            id = id.replace('?category=', ':')
                        }
                        if (rosetta.cateIDNum < 3 && id.length > 23 && isLocalID.test(id)) {
                            rosetta.cateIDNum += 1
                            if (rosetta.cateIDNum === 2) {
                                rosetta.cateID = id
                            }
                        }
                        // console.log('real id', id)
                        $item.on('click', function(e) {
                            // console.log('aa', $(e.target).parents('div#rosetta-query-container'))
                            // let source = $(event.target).closest('ProductDetail-relatedProducts-list').attr("id") === '' ? rosetta.source : null
                            let source =
                                !isNil($(e.target).parents('div#rosetta-query-container')) &&
                                $(e.target)
                                    .parents('div#rosetta-query-container')
                                    .attr('id') === 'rosetta-query-container'
                                    ? rosetta.source
                                    : null
                            // console.log('click no ng-click bindList', id)
                            try {

                                if (!isNil(localStorage.getItem('groupEvent'))) {
                                    // console.log('setitem 03 1')
                                    const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                    const newData = [...preData, { [timestamp]: ['click', id, null, false] }]
                                    localStorage.setItem('groupEvent', JSON.stringify(newData))
                                } else {
                                    // console.log('setitem 03 2')
                                    localStorage.setItem(
                                        'groupEvent',
                                        JSON.stringify([{ [timestamp]: ['click', id, null, false] }])
                                    )
                                }
                                // }
                                localStorage.setItem('queue', JSON.stringify(id))
                                // console.log(localStorage.getItem('queue')) // 如果商品有多樣規格，到商品頁才能知道詳細 id（這編取到的是 group_id）
                            } catch (error) {
                                // 不支援 localStorage
                            }
                        })
                        // console.log('mix_local_id',mix_local_id)
                    } else if (
                        id.indexOf('?variation=') === -1 &&
                        id.indexOf('?category=') === -1 &&
                        item.getAttribute('ng-click') &&
                        item.getAttribute('ng-click').indexOf('key') !== -1
                    ) {
                        // console.log('item have ng-click')
                        let clickDate = item
                            .getAttribute('ng-click')
                            .replace(/&quot;/g, '"')
                            .replace(/\\"/g, '"')
                        // console.log('clickDate',clickDate);
                        let variationId = clickDate.substr(clickDate.indexOf('key') + 6, 24)
                        // console.log('item ng-click',id,'variationId',variationId);
                        if (rosetta.cateIDNum < 3 && id.length > 23 && isLocalID.test(id)) {
                            rosetta.cateIDNum += 1
                            if (rosetta.cateIDNum === 2) {
                                rosetta.cateID = `${id}:${variationId}`
                            }
                        }
                        $item.on('click', function(e) {
                            // console.log('aa', $(e.target).parents('div#rosetta-query-container'))
                            // let source = $(event.target).closest('ProductDetail-relatedProducts-list').attr("id") === '' ? rosetta.source : null
                            let source =
                                !isNil($(e.target).parents('div#rosetta-query-container')) &&
                                $(e.target)
                                    .parents('div#rosetta-query-container')
                                    .attr('id') === 'rosetta-query-container'
                                    ? rosetta.source
                                    : null
                            // console.log('click ng-click bindList', `${id}:${variationId}`)
                            try {
                                // localStorage.removeItem('queue')
                                // if (rosetta.ab === 'on' && override) {
                                //   if (!isNil(localStorage.getItem('groupEvent'))) {
                                //     const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                //     const newData = [...preData, { [timestamp]: ['click', `${id}:${variationId}`, source, true] }]
                                //     localStorage.setItem('groupEvent', JSON.stringify(newData))
                                //   } else {
                                //     localStorage.setItem('groupEvent', JSON.stringify([{ [timestamp]: ['click', `${id}:${variationId}`, source, true] }]))
                                //   }
                                // } else if (rosetta.ab === 'off' && override) {
                                //   if (!isNil(localStorage.getItem('groupEvent'))) {
                                //     const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                //     const newData = [...preData, { [timestamp]: ['click', `${id}:${variationId}`, null, true] }]
                                //     localStorage.setItem('groupEvent', JSON.stringify(newData))
                                //   } else {
                                //     localStorage.setItem('groupEvent', JSON.stringify([{ [timestamp]: ['click', `${id}:${variationId}`, null, true] }]))
                                //   }
                                // } else {
                                if (!isNil(localStorage.getItem('groupEvent'))) {
                                    const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                    const newData = [
                                        ...preData,
                                        { [timestamp]: ['click', `${id}:${variationId}`, null, false] },
                                    ]
                                    localStorage.setItem('groupEvent', JSON.stringify(newData))
                                } else {
                                    localStorage.setItem(
                                        'groupEvent',
                                        JSON.stringify([
                                            { [timestamp]: ['click', `${id}:${variationId}`, null, false] },
                                        ])
                                    )
                                }
                                // }
                                localStorage.setItem('queue', JSON.stringify(`${id}:${variationId}`))
                                // console.log(localStorage.getItem('queue')) // 如果商品有多樣規格，到商品頁才能知道詳細 id（這編取到的是 group_id）
                            } catch (error) {
                                // 不支援 localStorage
                            }
                        })
                    } else {
                        if (rosetta.cateIDNum < 3 && id.length > 23 && isLocalID.test(id)) {
                            rosetta.cateIDNum += 1
                            if (rosetta.cateIDNum === 2) {
                                rosetta.cateID = id
                            }
                        }
                        $item.on('click', function(e) {
                            // console.log('aa', $(e.target).parents('div#rosetta-query-container'))
                            // let source = $(event.target).closest('ProductDetail-relatedProducts-list').attr("id") === '' ? rosetta.source : null
                            let source =
                                !isNil($(e.target).parents('div#rosetta-query-container')) &&
                                $(e.target)
                                    .parents('div#rosetta-query-container')
                                    .attr('id') === 'rosetta-query-container'
                                    ? rosetta.source
                                    : null
                            // console.log('click bind normal-click List', id)
                            try {
                                // localStorage.removeItem('queue')
                                // if (rosetta.ab === 'on' && override) {
                                //   if (!isNil(localStorage.getItem('groupEvent'))) {
                                //     const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                //     const newData = [...preData, { [timestamp]: ['click', id, source, true] }]
                                //     localStorage.setItem('groupEvent', JSON.stringify(newData))
                                //   } else {
                                //     localStorage.setItem('groupEvent', JSON.stringify([{ [timestamp]: ['click', id, source, true] }]))
                                //   }
                                // } else if (rosetta.ab === 'off' && override) {
                                //   if (!isNil(localStorage.getItem('groupEvent'))) {
                                //     const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                //     const newData = [...preData, { [timestamp]: ['click', id, null, true] }]
                                //     localStorage.setItem('groupEvent', JSON.stringify(newData))
                                //   } else {
                                //     localStorage.setItem('groupEvent', JSON.stringify([{ [timestamp]: ['click', id, null, true] }]))
                                //   }
                                // } else {
                                if (!isNil(localStorage.getItem('groupEvent'))) {
                                    const preData = JSON.parse(localStorage.getItem('groupEvent'))
                                    const newData = [...preData, { [timestamp]: ['click', id, null, false] }]
                                    localStorage.setItem('groupEvent', JSON.stringify(newData))
                                } else {
                                    localStorage.setItem(
                                        'groupEvent',
                                        JSON.stringify([{ [timestamp]: ['click', id, null, false] }])
                                    )
                                }
                                // }
                                localStorage.setItem('queue', JSON.stringify(id))
                                // console.log(localStorage.getItem('queue')) // 如果商品有多樣規格，到商品頁才能知道詳細 id（這編取到的是 group_id）
                            } catch (error) {
                                // 不支援 localStorage
                            }
                        })
                    }
                })
            },
            sendEvent(id, action, ...arg) {
                // 傳送事件
                // console.log('sendevent', id, action, ...arg)
                if (typeof rosetta.isLogin === 'boolean' && rosetta.user_entity) {
                    // 等待抓取登入資訊
                    const http = httpRequest(rosetta.token)
                    http.post('entity/local_retrieval', {
                        local_id: id,
                    })
                        .then(res => {
                            if (!isNil(action) && !isNil(res.data.id) && !isNil(arg[1])) {
                                return http.post('event', {
                                    actor: rosetta.user_entity,
                                    action: action,
                                    target: res.data.id,
                                    worthy_ab: arg[1],
                                    source: arg[0],
                                })
                            } else if (!isNil(action) && !isNil(res.data.id)) {
                                return http.post('event', {
                                    actor: rosetta.user_entity,
                                    action: action,
                                    target: res.data.id,
                                    worthy_ab: false,
                                    source: null,
                                })
                            }
                        })
                        .then(res => {
                            // 成功送出 event
                        })
                        .catch(err => {
                            // 錯誤
                        })
                } else {
                    // 尚未取得登入資訊
                    setTimeout(() => {
                        rosetta.sendEvent(id, action, ...arg)
                    }, 1000)
                }
            },
            override: false,
            lists: [],
            token: '',
            fingerPrint: '',
            isLogin: null,
            user_id: '',
            user_entity: '',
            engine_id: '',
            setTimes: 0,
            sendQueryTimes: 0,
            ab: '',
            source: null,
            getUser: false,
            cateID: '',
            cateIDNum: 0,
            // ab_experiments: ''
        }
    } catch (error) {
        throw new UserError(error)
    }
    initialize()
} catch (error) {
    Sentry.captureException(error)
}
